import constants from '../constants';

import { IfmsConfig } from './types';

import { stringsStartsWithIgnoreCase } from '../util';
import PeriodClosingDetails from "../components/accounting/reports/ClosingPeriod";
import YearEndProcessingDetails from "../components/accounting/reports/YearEndProcessing";
import { JobNames } from '../framework.core/JobNames';
import { FmsSecTask } from '../fms.core/constants';
import { FmsSubMenu } from '../constants/fmsSubMenu';
import { borderColors } from '../ui/ActionButton';
import { orchidBaroShipmentStatus, shipmentStatus } from '../components/common/OrchidBaroListView';
// let serverUrl = 'http://192.168.167.128:5000/api/';
// let serverUrl = 'http://cloud.suntekscm.co.kr/api/';
//let serverUrl = 'http://127.0.0.1:5000/api/';
//let serverUrl = 'https://ifms.suntekscm.co.kr/api/';
 let serverUrl = 'http://localtms.suntekscm.co.kr:5000/api/';

// //<pt220328: To test under same hostname with serverUrl value>
// if (serverUrl !== 'http://localhost:5000/api/' && process.env.NODE_ENV === 'production') {
//   serverUrl = 'http://localhost:5000/api/';
// }

//<231201.dwshin. serverUrl auto setting.>
if (process.env.NODE_ENV === 'production') {
  serverUrl = `${window.location.origin}/api/`;
}

const config: IfmsConfig = {
  serverUrl,
  dashboardUrl: 'https://dash2.suntekscm.com/Base/DashBoard?ver=1009',
  dashboardUrlDark: 'https://dash2.suntekscm.com/Base/DashBoard?ver=1010',
  menus: [
    // Ocean Import
    {
      operation: constants.operations.oceanImport,
      job: [
        {
          text: 'Master B/L',
          name: 'mbl',
          level: 0,
          link: '/common/joblistview/mbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/mbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIMbl,
          moreMenuJobName: JobNames.OIMbl,
        },
        {
          text: 'House B/L',
          name: 'hbl',
          level: 0,
          link: '/common/joblistview/hbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/hbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIHbl,
          moreMenuJobName: JobNames.OIHbl,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Container List',
          name: 'cntr',
          level: 0,
          link: '/common/joblistview/OICN/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OICN/oceanImport'),
          fmsSecTask: FmsSecTask.OIContainer,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Quotation',
          name: 'quot',
          level: 0,
          link: '/common/joblistview/oeQuotation/oceanExport?parentOp=oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeQuotation/oceanExport'),
          fmsSecTask: FmsSecTask.OIQuot,
        },
        {
          text: 'Load Plan',
          name: 'loadPlan',
          level: 0,
          link: '/common/joblistview/OILD/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OILD/oceanImport'),
          fmsSecTask: FmsSecTask.OITruckLoad,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Vessel Info',
          name: 'vessel',
          level: 0,
          link: '/common/joblistview/OIVS/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIVS/oceanImport'),
          fmsSecTask: FmsSecTask.OIVessel,
        },
        {
          text: 'Invoice',
          name: 'inv',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: 'Bill',
          name: 'bil',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        {
          text: 'CrDb',
          name: 'crdb',
          level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList,
        },
        {
          text: 'AMS',
          level: 0,
          topLineColor: borderColors[3 % borderColors.length],
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          textColor: 'orangered',
          items: [
            // {
            //   text: 'AMS Filing',
            //   name: 'amsFiling',
            //   level: 1,
            //   subMenu: FmsSubMenu.AmsFiling,
            // },
            // {
            //   text: 'Voyage',
            //   name: 'voyage',
            //   level: 1,
            //   link: '/common/joblistview/AMSV/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSV/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSVoyage,
            // },
            // {
            //   text: 'MBL',
            //   name: 'amsMbl',
            //   level: 1,
            //   link: '/common/joblistview/AMSM/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSM/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSMaster,
            // },
            // {
            //   text: 'HBL',
            //   name: 'amsHbl',
            //   level: 1,
            //   link: '/common/joblistview/AMSH/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSH/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSHouse,
            // },
            // {
            //   text: 'User',
            //   name: 'amsUser',
            //   level: 1,
            //   link: '/common/joblistview/AMSU/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSU/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSUser,
            // },
            // {
            //   text: 'AMS Branch',
            //   name: 'amsBranch',
            //   level: 1,
            //   link: '/common/joblistview/AMBR/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBR/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSBranch,
            // },
            // {
            //   text: 'AMS Billing Code',
            //   name: 'amsBilling',
            //   level: 1,
            //   link: '/common/joblistview/AMBI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBI/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSBilling,
            // },
            // {
            //   text: 'Filing History',
            //   name: 'amsFileHistory',
            //   level: 1,
            //   link: '/common/joblistview/AMHI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMHI/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSHistory,
            // },
            // {
            //   text: 'Customs Release History',
            //   name: 'amsCustHistory',
            //   level: 1,
            //   link: '/common/joblistview/AMC1/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMC1/oceanImport'),
            //   fmsSecTask: FmsSecTask.AMSC1History,
            // }, {
            //   text: 'Usage Report',
            //   level: 1,
            //   link: '/oceanImport/amsUsageReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsUsageReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptUsage
            // }, {
            //   text: 'Lifting Report',
            //   level: 1,
            //   link: '/oceanImport/amsLiftReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsLiftReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptLifting
            // }, {
            //   text: 'Total Lifting Report',
            //   level: 1,
            //   link: '/oceanImport/amsTotLiftReport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/amsTotLiftReport/'),
            //   fmsSecTask: FmsSecTask.AMSRptTotalLifting
            // },
          ]
        },
        {
          text: 'ACI eManifest', level: 0,
          name: 'aci',
          textColor: 'orangered',
          items: [
            // {
            //   text: 'Voyage List',
            //   level: 1,
            //   link: '/common/joblistview/ACIV/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIV/oceanImport')
            // },
            // {
            //   text: 'MBL List',
            //   level: 1,
            //   link: '/common/joblistview/ACIM/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIM/oceanImport')
            // },
            {
              text: 'House Bill',
              name: 'aciHbl',
              level: 1,
              link: '/common/joblistview/ACIEM/oceanImport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIEM/oceanImport'),
              fmsSecTask: FmsSecTask.ACIManifest
            },
            // {
            //   text: 'Users',
            //   level: 1,
            //   link: '/common/joblistview/ACIU/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACIU/oceanImport')
            // },
            // {
            //   text: 'Branch',
            //   level: 1,
            //   link: '/common/joblistview/ACBR/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACBR/oceanImport')
            // },
            // {
            //   text: 'ACI Filing History',
            //   level: 1,
            //   link: '/common/joblistview/ACHI/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ACHI/oceanImport')
            // },
            {
              text: 'ACI eManifest Usage Report',
              level: 1,
              link: '/oceanImport/aciUsageReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/aciUsageReport/'),
              fmsSecTask: FmsSecTask.AMSRptUsage
            },
            // {
            //   text: 'ACI eManifest Usage Report', 
            //   name:'aciUsageReport',
            //   level: 1, 
            //   popupComponent: <UsageReport mode={"ACI"} />, 
            //   fmsSecTask: FmsSecTask.AMSRptUsage},
            // {text: 'Lifting Report', level: 1},
            // {text: 'Total ACI Lifting', level: 1},
          ]
        },
        {
          text: 'ISF',
          name: 'isf',
          level: 0,
          link: '/common/joblistview/ISFL/isf',
          textColor: 'orangered',
          items: [
            // {
            //   text: 'ISF Filing',
            //   name: 'isfFiling',
            //   level: 1,
            //   subMenu: FmsSubMenu.IsfFiling,
            // },
            // {
            //   text: 'ISF List',
            //   name: 'isfList',
            //   level: 1,
            //   link: '/common/joblistview/ISFL/oceanImport',
            //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ISFL/oceanImport'),
            //   fmsSecTask: FmsSecTask.ISF,
            // },
          ]
        },
        {
          text: `AES Filing`,
          level: 0,
          name: 'aesFiling',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: 'Report', level: 0,
          name: 'report',
          topLineColor: borderColors[4 % borderColors.length],
          items: [
            {
              text: 'Arrival Notice Log',
              level: 1,
              link: '/oceanImport/arrivalnoticelog',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalnoticelog/'),
              fmsSecTask: FmsSecTask.OIRptANLog
            }, {
              text: 'Inland Transportation',
              level: 1,
              link: '/oceanImport/inlandTransportation',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/inlandTransportation/'),
              fmsSecTask: FmsSecTask.OIRptInlandTransport
            }, {
              text: 'Ocean Import ETA/ETD',
              level: 1,
              link: '/oceanImport/shipmentReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/shipmentReport/'),
              fmsSecTask: FmsSecTask.OIRptShipment
            }, {
              text: 'Pending Cargo',
              level: 1,
              link: '/oceanImport/pendingCargo',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pendingCargo/'),
              fmsSecTask: FmsSecTask.OIRptPendingCargo
            }, {
              text: 'Release History',
              level: 1,
              link: '/oceanImport/releaseHistory',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/releaseHistory/'),
              fmsSecTask: FmsSecTask.OIRptRlsHistory
            },]
        },
        {
          text: 'Download MBL',
          level: 0,
          link: '/common/joblistview/OIMP/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIMP/oceanImport'),
          fmsSecTask: FmsSecTask.OIMPims,
        },
        {
          text: 'Download HBL',
          level: 0,
          link: '/common/joblistview/OIHP/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OIHP/oceanImport'),
          fmsSecTask: FmsSecTask.OIHPims,
        },
      ],
      operationReport: [],
      download: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   topLineColor: '#007BFF',
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      moreMenu: [
        //Oim More Menu
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/oceanImport/arrivalnotice?jobname=@jobName&id=@jobid&isAtme=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalnotice/'),
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/correctionNotice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Master Invoice',
          level: 1,
          link: '/oceanImport/masterinvoice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/masterinvoice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pickupDelivery/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'USDA Hold Notice',
          level: 1,
          link: '/oceanImport/mblholdnotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/mblholdnotice/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Est. MBL Profit',
          level: 1,
          subMenu: FmsSubMenu.MasterProfit,
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        { text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'Cargo Manifest',
          level: 1,
          subMenu: FmsSubMenu.OICargoManifest,
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OIMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/folderLabel/'),
          moreMenuJobName: JobNames.OIMbl
        },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanImport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoList/'),
          moreMenuJobName: JobNames.OIMbl
        },
        { text: 'Out of State Log', level: 1, subMenu: FmsSubMenu.OutOfStateLog, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'CBP Status Query',
          level: 1,
          textColor: 'orangered',
          link: '/oceanImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OIMbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        //appcontext on off menu
        { text: 'CFS Manifest', level: 1, subMenu: FmsSubMenu.STARCFSMANI, moreMenuJobName: JobNames.OIMbl },
        {
          text: 'Devanning Instruction',
          level: 1,
          link: '/oceanImport/devanninginstruction?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/devanninginstruction/'),
          moreMenuJobName: JobNames.OIMbl
        },

        //Oih More Menu
        // { text: 'Arrival Notice', level: 1, popupComponent: <HblArrivalNotice jobName={JobNames.OIHbl} selectedElement={null} />, popupLabel: 'Arrival Notice (HBL)', moreMenuJobName: JobNames.OIHbl, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/oceanImport/hblArrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/hblArrivalNotice/'),
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        {
          text: 'Arrival Notice',
          level: 1,
          moreMenuJobName: JobNames.OIHbl,
          subMenu: FmsSubMenu.ArrivalNotice
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        // { text: 'Arrival/Release Notice', level: 1, popupComponent: <ArrivalReleaseNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Arrival/Release Notice',
          level: 1,
          link: '/oceanImport/arrivalReleaseNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/arrivalReleaseNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: '2nd Arrival Notice', level: 1, subMenu: FmsSubMenu._2ndArrivalNotice, moreMenuJobName: JobNames.OIHbl },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/correctionNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Delivery Order (Pre Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OIHbl} selectedElement={null} docType={DocumentType.DO} />, moreMenuJobName: JobNames.OIHbl },
        // {
        //   text: 'Delivery Order (Pre Form)',
        //   level: 1,
        //   link: '/oceanImport/preDeliveryOrder?jobname=@jobName&id=@jobid&docType=59',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/preDeliveryOrder/'),
        //   moreMenuJobName: JobNames.OIHbl
        // },
        // { text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OIHbl} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Delivery Order',
          level: 1,
          link: '/oceanImport/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OIHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/pickupDelivery/'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Print HBL', level: 1, subMenu: FmsSubMenu.OIHouseBL, moreMenuJobName: JobNames.OIHbl },
        //{ text: 'USDA Hold Notice', level: 1, popupComponent: <HblHoldNotice selectedElement={null} />, popupLabel: 'USDA Hold Notice (HBL)', moreMenuJobName: JobNames.OIHbl },
        {
          text: 'USDA Hold Notice',
          level: 1,
          link: '/oceanImport/hblHoldNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/hblHoldNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        {
          text: 'Est. HBL Profit',
          level: 1,
          subMenu: FmsSubMenu.HouseProfit,
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.OIHbl} />, moreMenuJobName: JobNames.OIHbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          textColor: 'orangered',
          link: '/oceanImport/cargoManifestStatus?jobname=@jobName&id=@jobid&oiMblId=@oiMblId',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        //appcontext on off menu
        {
          text: 'CFS Release', level: 1, moreMenuJobName: JobNames.OIHbl,
          name: 'cfsRelease', popupWidth: 900,
          popupComponent: <></>
        },
        //appcontext on off menu
        //{ text: 'EDI 315', level: 1, popupComponent: <SendShipmentStatus />, popupWidth: 760, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'EDI 315',
          level: 1,
          link: '/oceanImport/sendShipmentStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/sendShipmentStatus'),
          moreMenuJobName: JobNames.OIHbl
        },
        {
          text: 'Carrier\'s Certificate',
          level: 1,
          subMenu: FmsSubMenu.CarrierCertificate,
          moreMenuJobName: JobNames.OIHbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        // { text: 'Empty CNTR Return Guarantee', level: 1, popupComponent: <EmptyContainerReturnGuarantee selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Empty CNTR Return Guarantee',
          level: 1,
          link: '/oceanImport/emptyContainerReturnGuarantee?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/emptyContainerReturnGuarantee'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.OIHbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OIHbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/folderLabel/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'I.T Cancel Notice', level: 1, popupComponent: <CancelNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'I.T Cancel Notice',
          level: 1,
          link: '/oceanImport/cancelNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cancelNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.OIHbl} selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/oceanImport/itTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/itTeNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Lien Notice', level: 1, popupComponent: <LienNotice selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Lien Notice',
          level: 1,
          link: '/oceanImport/lienNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/lienNotice'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OIHbl} />, popupLabel: 'Memo List (HBL)', moreMenuJobName: JobNames.OIHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanImport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoList/'),
          moreMenuJobName: JobNames.OIHbl
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/oceanImport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/memoCustomerList/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/oceanImport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/packageLabel/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Preliminary Claim Notice', level: 1, popupComponent: <PreliminaryClaimNotice jobName={JobNames.OIHbl} selectedElement={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Preliminary Claim Notice',
          level: 1,
          link: '/oceanImport/preliminaryClaimNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/preliminaryClaimNotice/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Proof of Delivery', level: 1, popupComponent: <ProofOfDelivery selectedElement={null} jobName={JobNames.OIHbl} />, popupWidth: 790, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Proof of Delivery',
          level: 1,
          link: '/oceanImport/proofOfDelivery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/proofOfDelivery/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Release Order/Turnover', level: 1, popupComponent: <ReleaseOrderTurnover jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Release Order/Turnover',
          level: 1,
          link: '/oceanImport/releaseOrderTurnover?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/releaseOrderTurnover/'),
          moreMenuJobName: JobNames.OIHbl
        },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OIHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/oceanImport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/straightBl/'),
          moreMenuJobName: JobNames.OIHbl
        },
        { text: 'Work Sheet', level: 1, subMenu: FmsSubMenu.WorkSheet, moreMenuJobName: JobNames.OIHbl },
        // {
        //   text: 'ISF Usage',
        //   level: 1,
        //   link: '/oceanImport/isfUsage?jobname=@jobName',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/isfUsage'),
        //   moreMenuJobName: JobNames.ISF
        // },
        //Download MBL More Menu
        // { text: 'Download MBL (All) List', level: 1, moreMenuJobName: JobNames.OIMPims },
        // { text: 'Download MBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OIMPims },
        // { text: 'Download MBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OIMPims },

        //Download HBL More Menu
        // { text: 'Download HBL (All) List', level: 1, moreMenuJobName: JobNames.OIHPims },
        // { text: 'Download HBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OIHPims },
        // { text: 'Download HBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OIHPims },
      ]
    },
    // Ocean export
    {
      operation: constants.operations.oceanExport,
      job: [
        {
          text: 'Quotation',
          level: 0,
          link: '/common/joblistview/oeQuotation/oceanExport?parentOp=oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeQuotation/oceanExport'),
          fmsSecTask: FmsSecTask.OEQuot,
        },
        {
          text: 'Booking',
          level: 0,
          link: '/common/joblistview/oeBooking/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeBooking/oceanExport'),
          fmsSecTask: FmsSecTask.OEBook,
          moreMenuJobName: JobNames.OEBook,
        },
        {
          text: 'House B/L',
          level: 0,
          link: '/common/joblistview/oeHbl/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeHbl/oceanExport'),
          fmsSecTask: FmsSecTask.OEHbl,
          moreMenuJobName: JobNames.OEHbl,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Master B/L',
          level: 0,
          link: '/common/joblistview/oeMbl/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeMbl/oceanExport'),
          fmsSecTask: FmsSecTask.OEMbl,
          moreMenuJobName: JobNames.OEMbl,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Container List',
          level: 0,
          link: '/common/joblistview/oeContainerStatus/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeContainerStatus/oceanExport'),
          fmsSecTask: FmsSecTask.OEContainer,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Load Plan',
          level: 0,
          link: '/common/joblistview/oeLoadPlan/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/oeLoadPlan/oceanExport'),
          fmsSecTask: FmsSecTask.OELoad,
        },
        {
          text: 'Invoice',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: 'Bill',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        {
          text: 'CrDb',
          level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          textColor: 'orangered',
          link: '/common/joblistview/AMSM/ams',
          topLineColor: borderColors[3 % borderColors.length]
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          textColor: 'orangered',
          link: '/common/joblistview/ISFL/isf',
        },
        {
          text: `AES Filing`,
          level: 0,
          name: 'aesFiling',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: 'Report',
          level: 0,
          topLineColor: borderColors[4 % borderColors.length],
          items: [
            {
              text: 'Ocean Export Shipment',
              level: 1,
              link: '/oceanExport/shipmentReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shipmentReport/'),
              fmsSecTask: FmsSecTask.OERptShipment
            }, {
              text: 'Brokerage',
              level: 1,
              link: '/oceanExport/brokerageReport',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/brokerageReport/'),
              fmsSecTask: FmsSecTask.OERptBrokerage
            },
            // {text: 'Est. Profit/Volume Summary Report', level: 1},
          ],
        },
        {
          text: 'Download MBL',
          level: 0,
          link: '/common/joblistview/OEMP/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OEMP/oceanExport'),
          fmsSecTask: FmsSecTask.OEMPims,
        },
        {
          text: 'Download HBL',
          level: 0,
          link: '/common/joblistview/OEHP/oceanExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OEHP/oceanExport'),
          fmsSecTask: FmsSecTask.OEHPims,
        },
        /*{
          text: 'Booking Status', level: 0,
          items: [
            { text: 'Customer Booking ', level: 1 },
            { text: 'Carrier Booking ', level: 1 },
          ]
        },*/
        // {
        //   text: 'Load Plan', level: 0,
        // },
        /*{
            text: '	W/H Receipt', level: 0,
        },
        {
            text: 'Container Tracking', level: 0,
        },*/
      ],
      download: [],
      operationReport: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      moreMenu: [
        //Oem More Menu
        // { text: 'AES Filing (Portal)', level: 1, popupComponent: <AesFiling jobName={JobNames.OEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'AES Filing (Portal)',
          level: 1,
          link: '/oceanExport/aesFiling?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/aesFiling/'),
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/correctionNotice/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEMbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Batch Print House B/L', level: 1, popupComponent: <OemBatchPrint jobName={JobNames.OEMbl} selectedElement={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Batch Print House B/L',
          level: 1,
          link: '/oceanExport/oemBatchPrint?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/oemBatchPrint/'),
          moreMenuJobName: JobNames.OEMbl
        },
        {
          text: 'Est. MBL Profit',
          level: 1,
          subMenu: FmsSubMenu.MasterProfit,
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[1 % borderColors.length] 
        },
        { text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.OEMbl },
        // { text: 'Agent Document Package', level: 1, popupComponent: <AgentDocumentPackage selectedElement={null} jobName={JobNames.OEMbl} />, moreMenuJobName: JobNames.OEMbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'Agent Document Package',
          level: 1,
          link: '/oceanExport/agentDocumentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/agentDocumentPackage/'),
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        // { text: 'Container Load Plan', level: 1, popupComponent: <ContainerLoadPlan selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Container Load Plan',
          level: 1,
          link: '/oceanExport/containerLoadPlan?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/containerLoadPlan'),
          moreMenuJobName: JobNames.OEMbl
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEMbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OEMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/folderLabel/'),
          moreMenuJobName: JobNames.OEMbl
        },
        { text: 'MBL/Shipping Request', level: 1, subMenu: FmsSubMenu.MasterSet, moreMenuJobName: JobNames.OEMbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OEMbl} />, popupLabel: 'Memo List (MBL)', moreMenuJobName: JobNames.OEMbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoList/'),
          moreMenuJobName: JobNames.OEMbl
        },
        // { text: 'Ocean Cargo Manifest', level: 1, popupComponent: <CargoManifest jobName={JobNames.OEMbl} selectedElement={null} />, moreMenuJobName: JobNames.OEMbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'Ocean Cargo Manifest',
          level: 1,
          link: '/oceanExport/cargoManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanImport/cargoManifest/'),
          moreMenuJobName: JobNames.OEMbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        { text: 'Telex Release', level: 1, subMenu: FmsSubMenu.TelexReleaseMessage, moreMenuJobName: JobNames.OEMbl },
        //appcontext on off menu
        //{ text: 'Carrier Shipping Instruction', level: 1, moreMenuJobName: JobNames.OEMbl }, // <250205.dwshin. releated pims. remove menu.>
        //appcontext on off menu
        // { text: 'B/L EDI', level: 1, popupComponent: <SendBl jobName={JobNames.OEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEMbl },
        {
          text: 'B/L EDI',
          level: 1,
          link: '/oceanExport/sendBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/sendBl/'),
          moreMenuJobName: JobNames.OEMbl
        },

        //Oeh More Menu
        // { text: 'AES Filing (Portal)', level: 1, popupComponent: <AesFiling jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'AES Filing (Portal)',
          level: 1,
          link: '/oceanExport/aesFiling?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/aesFiling/'),
          moreMenuJobName: JobNames.OEHbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        // { text: 'AES Filing', level: 1, subMenu: FmsSubMenu.AesOcean, moreMenuJobName: JobNames.OEHbl },
        { text: 'Booking Confirmation', level: 1, subMenu: FmsSubMenu.OOHBook, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/oceanExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/correctionNotice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Print House B/L', level: 1, popupComponent: <PrintHbl selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Print House B/L',
          level: 1,
          link: '/oceanExport/printHbl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/printHbl/'),
          moreMenuJobName: JobNames.OEHbl
        },
        {
          text: 'Est. HBL Profit',
          level: 1,
          subMenu: FmsSubMenu.HouseProfit,
          moreMenuJobName: JobNames.OEHbl,
          //topLineColor: borderColors[1 % borderColors.length] 
        },
        // { text: 'Bank Draft', level: 1, popupComponent: <BankDraft jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl, topLineColor: borderColors[2 % borderColors.length] },
        {
          text: 'Bank Draft',
          level: 1,
          link: '/oceanExport/bankDraft?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/bankDraft/'),
          moreMenuJobName: JobNames.OEHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        { text: 'Certificate of Heat Treatment', level: 1, subMenu: FmsSubMenu.OEUSDA, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin selectedElementId={null} jobName={JobNames.OEHbl} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Certificate of Origin',
          level: 1,
          link: '/oceanExport/certificateOfOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/certificateOfOrigin/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Commercial Invoice', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptCommercialInvoice} tbName={getTbNameByJobName(JobNames.OEHbl)} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Commercial Invoice',
          level: 1,
          link: '/oceanExport/commercialInvoice?jobname=@jobName&id=@jobid&rptType=RPCOINV',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/commercialInvoice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEHbl },
        // { text: 'Document Package', level: 1, popupComponent: <DocumentPackage jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Document Package',
          level: 1,
          link: '/oceanExport/documentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/documentPackage/'),
          moreMenuJobName: JobNames.OEHbl
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.OEHbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.OEHbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/oceanExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/folderLabel/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/oceanExport/itTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/itTeNotice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.OEHbl} />, popupLabel: 'Memo List (HBL)', moreMenuJobName: JobNames.OEHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/oceanExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/oceanExport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/memoCustomerList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/oceanExport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/packageLabel/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Packing List', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptPackingList} tbName={getTbNameByJobName(JobNames.OEHbl)} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Packing List',
          level: 1,
          link: '/oceanExport/packingList?jobname=@jobName&id=@jobid&rptType=RPPACKL',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/packingList/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.OEHbl} selectedElement={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Shipping Advice',
          level: 1,
          link: '/oceanExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shippingAdvice/'),
          moreMenuJobName: JobNames.OEHbl
        },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.OEHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/oceanExport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/straightBl/'),
          moreMenuJobName: JobNames.OEHbl
        },

        //Booking More Menu
        {
          text: 'Booking Confirmation',
          level: 1,
          subMenu: FmsSubMenu.OOHBook,
          moreMenuJobName: JobNames.OEBook,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        // { text: 'Booking Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelBook} jobName={JobNames.OEBook} selectedElementId={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Booking Label',
          level: 1,
          link: '/oceanExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/airLabel/'),
          moreMenuJobName: JobNames.OEBook
        },
        { text: 'Dock Receipt', level: 1, subMenu: FmsSubMenu.DockReceipt, moreMenuJobName: JobNames.OEBook },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OEBook} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/oceanExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/pickupDelivery/'),
          moreMenuJobName: JobNames.OEBook
        },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.OEBook} selectedElement={null} />, moreMenuJobName: JobNames.OEBook },
        {
          text: 'Shipping Advice',
          level: 1,
          link: '/oceanExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/oceanExport/shippingAdvice/'),
          moreMenuJobName: JobNames.OEBook
        },

        //Download MBL More Menu
        // { text: 'Download MBL (All) List', level: 1, moreMenuJobName: JobNames.OEMPims },
        // { text: 'Download MBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OEMPims },
        // { text: 'Download MBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OEMPims },

        //Download HBL More Menu
        // { text: 'Download HBL (All) List', level: 1, moreMenuJobName: JobNames.OEHPims },
        // { text: 'Download HBL (Downloaded) List', level: 1, moreMenuJobName: JobNames.OEHPims },
        // { text: 'Download HBL (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.OEHPims },
      
      ]
    },
    // Air Import
    {
      operation: constants.operations.airImport,
      job: [
        {
          text: 'Master AWB',
          level: 0,
          link: '/common/joblistview/aiMawb/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aiMawb/airImport'),
          fmsSecTask: FmsSecTask.AIMbl,
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'House AWB',
          level: 0,
          link: '/common/joblistview/aiHawb/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aiHawb/airImport'),
          fmsSecTask: FmsSecTask.AIHbl,
          moreMenuJobName: JobNames.AIHbl,
        },
        {
          text: 'Quotation',
          level: 0,
          link: '/common/joblistview/aeQuotation/airExport?parentOp=airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeQuotation/airExport'),
          fmsSecTask: FmsSecTask.AIQuot,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Invoice', level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Bill', level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        {
          text: 'CrDb', level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          textColor: 'orangered',
        },
        {
          text: `AES Filing`,
          level: 0,
          name: 'aesFiling',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: 'Pre Alert Report', level: 0,
          link: '/airImport/preAlert',
          fmsSecTask: FmsSecTask.AIRptPreAlert,
          topLineColor: borderColors[3 % borderColors.length],
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preAlert/'),
        },
        {
          text: 'Air Import Est. Profit Report', level: 1,
          link: '/airImport/estProfit?docType=705&isManagerReport=true&opType=airImport',
          fmsSecTask: FmsSecTask.AIRptEstProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/estProfit'),
        },
        {
          text: 'Download MAWB',
          level: 0,
          link: '/common/joblistview/AIMP/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AIMP/airImport'),
          fmsSecTask: FmsSecTask.AIMPims,
        },
        {
          text: 'Download HAWB',
          level: 0,
          link: '/common/joblistview/AIHP/airImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AIHP/airImport'),
          fmsSecTask: FmsSecTask.AIHPims,
        },
      ],
      download: [],
      operationReport: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [],
      /*download: [
        {
          text: <span>Report <span style={{fontSize: '0.8em'}}>(AI)</span></span>, level: 0,
          items: [
            { text: 'Pre Alert Report', level: 1, popupComponent: <PreAlertDetails /> },
            { text: 'Est. Profilt/Volume Summary Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails opType={'airImport'} /> },
          ]
        },
        {
          text: 'Download', level: 0,
          items: [
            { text: 'Download My MBL (AI)', level: 1 },
            { text: 'Donwload My HBL (AI)', level: 1 },
            { text: 'Download All MBL (AI)', level: 1 },
            { text: 'Donwload All HBL (AI)', level: 1 },
            { text: 'Shipping Order (AI)', level: 1 },
          ]
        },
        {
          text: <span>Billings & Report <span style={{fontSize: '0.8em'}}>(Manager)</span></span>, level: 0,
          items: [
            { text: 'Invoice List', level: 1 },
            { text: 'Bill List', level: 1 },
            { text: 'CrDb List', level: 1 },
            { text: 'Est. Profilt/Volume Summary Report', level: 1 },
            { text: 'Gross Profit/Volume Summary Report', level: 1 },
            { text: 'Vendor Cost Report', level: 1 },
            { text: 'Volume Report', level: 1 },
            { text: 'Sales Performance Report', level: 1 },
            { text: 'Customer Activity Report', level: 1 },
            { text: 'Duty Pendings', level: 1 },
            { text: 'Issue Ready Invoice Report', level: 1 },
            { text: 'Issue Ready Bill Report', level: 1 },
            { text: 'Issue Ready Cr/Db Report', level: 1 },
            { text: 'Operation Performance Report', level: 1 },
            { text: 'Branch Performance Report', level: 1 },
          ]
        },
        {
          text: <span>Report <span style={{fontSize: '0.8em'}}>(AI)</span></span>, level: 0,
          items: [
            { text: 'Pre Alert Report', level: 1, popupComponent: <PreAlertDetails /> },
            { text: 'Est. Profilt/Volume Summary Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails opType={'airImport'} /> },
          ]
        },
        {
          text: 'EDI', level: 0,
          items: [
            { text: 'FS3.0 EDI', level: 1 },
            { text: 'B/L from Oversea Partner', level: 1 },
          ]
        },
      ],*/
      /*download: [
        {
          text: 'Download', level: 0,
          items: [
            { text: 'Download My MBL (AI)', level: 1 },
            { text: 'Donwload My HBL (AI)', level: 1 },
            { text: 'Download All MBL (AI)', level: 1 },
            { text: 'Donwload All HBL (AI)', level: 1 },
            { text: 'Shipping Order (AI)', level: 1 },
          ]
        },
        {
          text: 'EDI', level: 0,
          items: [
            { text: 'FS3.0 EDI', level: 1 },
            { text: 'B/L from Oversea Partner', level: 1 },
          ]
        },
      ],*/
      /*report: [
        {
          text: <span>Billings & Report <span style={{fontSize: '0.8em'}}>(Manager)</span></span>, level: 0,
          items: [
            { text: 'Invoice List', level: 1 },
            { text: 'Bill List', level: 1 },
            { text: 'CrDb List', level: 1 },
            { text: 'Est. Profilt/Volume Summary Report', level: 1 },
            { text: 'Gross Profit/Volume Summary Report', level: 1 },
            { text: 'Vendor Cost Report', level: 1 },
            { text: 'Volume Report', level: 1 },
            { text: 'Sales Performance Report', level: 1 },
            { text: 'Customer Activity Report', level: 1 },
            { text: 'Duty Pendings', level: 1 },
            { text: 'Issue Ready Invoice Report', level: 1 },
            { text: 'Issue Ready Bill Report', level: 1 },
            { text: 'Issue Ready Cr/Db Report', level: 1 },
            { text: 'Operation Performance Report', level: 1 },
            { text: 'Branch Performance Report', level: 1 },
          ]
        },
        {
          text: <span>Report <span style={{fontSize: '0.8em'}}>(AI)</span></span>, level: 0,
          items: [
            { text: 'Pre Alert Report', level: 1, 
             : <PreAlertDetails /> },
            { text: 'Est. Profilt/Volume Summary Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails opType={'airImport'} /> },
          ]
        },
      ]*/
      moreMenu: [
        //Aim More Menu
        {
          text: 'Air Cargo Manifest',
          level: 1,
          subMenu: FmsSubMenu.AICargoManifest,
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/airImport/arrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/arrivalNotice/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Authority to Make Entry',
          level: 1,
          link: '/airImport/AuthorityToMakeEntry?jobname=@jobName&id=@jobid&isAtme=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/AuthorityToMakeEntry/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'IRC-225',
          level: 1,
          link: '/airImport/IRC225?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/IRC225/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/correctionNotice/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        {
          text: 'Est. MBL Profit',
          level: 1,
          subMenu: FmsSubMenu.MasterProfit,
          moreMenuJobName: JobNames.AIMbl,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        { text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AIMbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AIMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/airImport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/folderLabel/'),
          moreMenuJobName: JobNames.AIMbl
        },
        //{ text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AIMbl} />, popupLabel: 'Memo List (MAWB)', moreMenuJobName: JobNames.AIMbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/airImport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIMbl,
        },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.AIMbl} />, moreMenuJobName: JobNames.AIMbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          textColor: 'orangered',
          link: '/airImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.AIMbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        //Aih More Menu
        //{ text: 'Arrival Notice', level: 1, popupComponent: <HblArrivalNotice selectedElement={null} jobName={JobNames.AIHbl} />, popupLabel: 'Arrival Notice (HAWB)', topLineColor: borderColors[0 % borderColors.length],moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Arrival Notice',
          level: 1,
          link: '/airImport/hblArrivalNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/hblArrivalNotice/'),
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Arrival Notice',
          level: 1,
          moreMenuJobName: JobNames.AIHbl,
          subMenu: FmsSubMenu.ArrivalNotice
          //topLineColor: borderColors[0 % borderColors.length] 
        },
        { text: 'Authority to Make Entry', level: 1, subMenu: FmsSubMenu.AuthEntry, moreMenuJobName: JobNames.AIHbl },
        //{ text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airImport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/correctionNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Delivery Order (Pre Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={null} docType={DocumentType.DO} />, moreMenuJobName: JobNames.AIHbl },
        // {
        //   text: 'Delivery Order (Pre Form)',
        //   level: 1,
        //   link: '/airImport/preDeliveryOrder?jobname=@jobName&id=@jobid&docType=59',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preDeliveryOrder/'),
        //   moreMenuJobName: JobNames.AIHbl,
        // },
        //{ text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.AIHbl} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Delivery Order',
          level: 1,
          link: '/airImport/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AIHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airImport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/pickupDelivery/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        {
          text: 'Est. HBL Profit',
          level: 1,
          subMenu: FmsSubMenu.HouseProfit,
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Carrier\'s Certificate',
          level: 1,
          subMenu: FmsSubMenu.CarrierCertificate,
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        { text: 'Export Declaration for Transit', level: 1, subMenu: FmsSubMenu.ExdecTransit, moreMenuJobName: JobNames.AIHbl },
        //{ text: 'Print 7512', level: 1, popupComponent: <ItTeNotice jobName={JobNames.AIHbl} selectedElement={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Print 7512',
          level: 1,
          link: '/airImport/ItTeNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/ItTeNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AIHbl} />, popupLabel: 'Memo List (HAWB)', moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Memo List',
          level: 1,
          link: '/airImport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/memoList/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/airImport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/memoCustomerList/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Package Label',
          level: 1,
          link: '/airImport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/packageLabel/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Preliminary Claim Notice', level: 1, popupComponent: <PreliminaryClaimNotice jobName={JobNames.AIHbl} selectedElement={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Preliminary Claim Notice',
          level: 1,
          link: '/airImport/preliminaryClaimNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/preliminaryClaimNotice/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Proof of Delivery', level: 1, popupComponent: <ProofOfDelivery selectedElement={null} jobName={JobNames.AIHbl} />, popupWidth: 790, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Proof of Delivery',
          level: 1,
          link: '/airImport/proofOfDelivery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/proofOfDelivery/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Release Order/Turnover', level: 1, popupComponent: <ReleaseOrderTurnover jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl  },
        {
          text: 'Release Order/Turnover',
          level: 1,
          link: '/airImport/releaseOrderTurnover?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/releaseOrderTurnover/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.AIHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AIHbl },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/airImport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/straightBl/'),
          moreMenuJobName: JobNames.AIHbl,
        },
        //{ text: 'Cargo Status Query', level: 1, popupComponent: <CargoManifestStatus selectedElement={null} jobName={JobNames.AIHbl} />, moreMenuJobName: JobNames.AIHbl, topLineColor: borderColors[3 % borderColors.length] },
        {
          text: 'CBP Status Query',
          level: 1,
          textColor: 'orangered',
          link: '/airImport/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airImport/cargoManifestStatus/'),
          moreMenuJobName: JobNames.AIHbl,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        //Download MAWB More Menu
        // { text: 'Download MAWB (All) List', level: 1, moreMenuJobName: JobNames.AIMPims },
        // { text: 'Download MAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AIMPims },
        // { text: 'Download MAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AIMPims },

        //Download HAWB More Menu
        // { text: 'Download HAWB (All) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        // { text: 'Download HAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        // { text: 'Download HAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AIHPims },
        {
          text: 'Print HAWB',
          level: 1,
          subMenu: FmsSubMenu.AIAWB,
          moreMenuJobName: JobNames.AIHbl,
        },
      ]
    },
    // Air Export
    {
      operation: constants.operations.airExport,
      job: [
        {
          text: 'Quotation', level: 0,
          link: '/common/joblistview/aeQuotation/airExport?parentOp=airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeQuotation/airExport'),
          fmsSecTask: FmsSecTask.AEQuot,
        },
        {
          text: 'Master AWB',
          level: 0,
          link: '/common/joblistview/aeMawb/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeMawb/airExport'),
          fmsSecTask: FmsSecTask.AEMbl,
          moreMenuJobName: JobNames.AEMbl,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'House AWB',
          level: 0,
          link: '/common/joblistview/aeHawb/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/aeHawb/airExport'),
          fmsSecTask: FmsSecTask.AEHbl,
          moreMenuJobName: JobNames.AEHbl,
        },
        {
          text: 'Invoice', level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Bill', level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        {
          text: 'CrDb', level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          textColor: 'orangered',
        },
        {
          text: `AES Filing`,
          level: 0,
          name: 'aesFiling',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: 'Air Export Est. Profit Report', level: 1,
          topLineColor: borderColors[3 % borderColors.length],
          link: '/airExport/estProfit?docType=705&isManagerReport=true&opType=airExport',
          fmsSecTask: FmsSecTask.AERptEstProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/estProfit'),
        },
        {
          text: 'Download MAWB',
          level: 0,
          link: '/common/joblistview/AEMP/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AEMP/airExport'),
          fmsSecTask: FmsSecTask.AEMPims,
        },
        {
          text: 'Download HAWB',
          level: 0,
          link: '/common/joblistview/AEHP/airExport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AEHP/airExport'),
          fmsSecTask: FmsSecTask.AEHPims,
        },
      ],
      download: [],
      operationReport: [],
      report: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      moreMenu: [
        //Aem More Menu
        {
          text: 'AES Filing (Portal)',
          level: 1,
          link: '/airExport/aesFiling?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aesFiling/'),
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/correctionNotice/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pickupDelivery/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Print MAWB',
          level: 1,
          link: '/airExport/aemPrintMawb?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemPrintMawb/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Batch Print HAWB',
          level: 1,
          link: '/airExport/aemBatchPrint?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemBatchPrint/'),
          moreMenuJobName: JobNames.AEMbl,
        },
        {
          text: 'Est. MBL Profit',
          level: 1,
          subMenu: FmsSubMenu.MasterProfit,
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        { text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AEMbl },
        {
          text: 'Agent Document Package',
          level: 1,
          link: '/airExport/agentDocument?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/agentDocument/'),
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[2 % borderColors.length] 
        }, {
          text: 'Air Cargo Manifest',
          level: 1,
          link: '/airExport/cargoManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/cargoManifest/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Air Label',
          level: 1,
          link: '/airExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/airLabel/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Pouch Air Label',
          level: 1,
          link: '/airExport/pouchAirLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pouchAirLabel/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Certificate of Origin',
          level: 1,
          link: '/airExport/certificationOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/certificationOrigin/'),
          moreMenuJobName: JobNames.AEMbl,
        },
        { text: 'IAC Certificate (Known)', level: 1, subMenu: FmsSubMenu.TsaSecurity, moreMenuJobName: JobNames.AEMbl },
        { text: 'IAC Certificate (Unknown)', level: 1, subMenu: FmsSubMenu.TsaUnknown, moreMenuJobName: JobNames.AEMbl },
        //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AEMbl, metadata: { isDirectPrint: true } },
        {
          text: 'Folder Label',
          level: 1,
          link: '/airExport/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/folderLabel/'),
          moreMenuJobName: JobNames.AEMbl
        },
        {
          text: 'Memo List',
          level: 1,
          link: '/airExport/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoList/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Shipping Advice',
          level: 1,
          link: '/airExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/shippingAdvice/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Transfer Manifest',
          level: 1,
          link: '/airExport/transferManifest?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/transferManifest/'),
          moreMenuJobName: JobNames.AEMbl,
        }, {
          text: 'Send B/L to Partner',
          level: 1,
          link: '/airExport/sendBLtoPatner?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/sendBLtoPatner/'),
          moreMenuJobName: JobNames.AEMbl,
          //topLineColor: borderColors[3 % borderColors.length] 
        },

        // { text: 'AES Filing (Portal)', level: 1, popupComponent: <AesFiling jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[0 % borderColors.length] },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AEMbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Print MAWB', level: 1, popupComponent: <Print jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Batch Print HAWB', level: 1, popupComponent: <BatchPrint selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'Est. MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfit, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[1 % borderColors.length] },
        // //{ text: 'Gross MBL Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Agent Document Package', level: 1, popupComponent: <AgentDocumentPackage jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[2 % borderColors.length] },
        // { text: 'Air Cargo Manifest', level: 1, popupComponent: <CargoManifest jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Air Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelAir} selectedElementId={null} jobName={JobNames.AEMbl} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Pouch Air Label', level: 1, popupComponent: <PouchAirLabel selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin selectedElementId={null} jobName={JobNames.AEMbl} />, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'IAC Certificate (Known)', level: 1, subMenu: FmsSubMenu.TsaSecurity, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'IAC Certificate (Unknown)', level: 1, subMenu: FmsSubMenu.TsaUnknown, moreMenuJobName: JobNames.AEMbl },
        // //{ text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AEMbl} />, popupLabel: 'Memo List (MAWB)', moreMenuJobName: JobNames.AEMbl },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.AEMbl} selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Transfer Manifest', level: 1, popupComponent: <TransferManifest selectedElement={null} />, moreMenuJobName: JobNames.AEMbl },
        // { text: 'Send B/L to Partner', level: 1, popupComponent: <SendBl jobName={JobNames.AEMbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEMbl, topLineColor: borderColors[3 % borderColors.length] },

        //Aeh More Menu

        {
          text: 'AES Filing (Portal)',
          level: 1,
          link: '/airExport/aesFiling?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aesFiling/'),
          moreMenuJobName: JobNames.AEHbl,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        // { text: 'AES Filing', level: 1, subMenu: FmsSubMenu.AesAir, moreMenuJobName: JobNames.AEHbl },
        {
          text: 'Correction Notice/Request',
          level: 1,
          link: '/airExport/correctionNotice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/correctionNotice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/airExport/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/pickupDelivery/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Print HAWB',
          level: 1,
          link: '/airExport/aemPrintHawb?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/aemPrintHawb/'),
          moreMenuJobName: JobNames.AEHbl,
        },
        {
          text: 'Est. HBL Profit',
          level: 1,
          subMenu: FmsSubMenu.HouseProfit,
          moreMenuJobName: JobNames.AEHbl,
          //topLineColor: borderColors[1 % borderColors.length] 
        },
        {
          text: 'Air Label',
          level: 1,
          link: '/airExport/airLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/airLabel/'),
          moreMenuJobName: JobNames.AEHbl,
          //topLineColor: borderColors[2 % borderColors.length]
        }, {
          text: 'Bank Draft',
          level: 1,
          link: '/airExport/bankDraft?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/bankDraft/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Certificate of Origin',
          level: 1,
          link: '/airExport/certificationOrigin?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/certificationOrigin/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Document Package',
          level: 1,
          link: '/airExport/documentPackage?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/documentPackage/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Commercial Invoice',
          level: 1,
          link: '/airExport/commercialInvoice?jobname=@jobName&id=@jobid&rptType=RPCOINV',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/commercialInvoice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Memo List',
          level: 1,
          link: '/airExport/memoList?jobname=@jobName&id=@jobid&isCompany=false',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/airExport/memoCustomerList?jobname=@jobName&id=@jobid&isCompany=true',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/memoCustomerList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Package Label',
          level: 1,
          link: '/airExport/packageLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/packageLabel/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Packing List',
          level: 1,
          link: '/airExport/packingList?jobname=@jobName&id=@jobid&rptType=RPPACKL',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/packingList/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Shipping Advice',
          level: 1,
          link: '/airExport/shippingAdvice?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/shippingAdvice/'),
          moreMenuJobName: JobNames.AEHbl,
        }, {
          text: 'Straight B/L',
          level: 1,
          link: '/airExport/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/airExport/straightBl/'),
          moreMenuJobName: JobNames.AEHbl,
        },

        // { text: 'AES Filing (Portal)', level: 1, popupComponent: <AesFiling jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl, topLineColor: borderColors[0 % borderColors.length] },
        // { text: 'AES Filing (iPims)', level: 1, link: 'https://ipims.suntekscm.com/home/loginrequest/' },
        // { text: 'Correction Notice/Request', level: 1, popupComponent: <CorrectionNotice jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.AEHbl} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Print HAWB', level: 1, popupComponent: <Print jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Est. HBL Profit', level: 1, subMenu: FmsSubMenu.HouseProfit, moreMenuJobName: JobNames.AEHbl, topLineColor: borderColors[1 % borderColors.length] },
        // { text: 'Air Label', level: 1, popupComponent: <AirLabel docType={DocumentType.LabelAir} jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl, topLineColor: borderColors[2 % borderColors.length] },
        // { text: 'Bank Draft', level: 1, popupComponent: <BankDraft jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Certificate of Origin', level: 1, popupComponent: <CertificateOfOrigin jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Document Package', level: 1, popupComponent: <DocumentPackage jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Commercial Invoice', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptCommercialInvoice} tbName={getTbNameByJobName(JobNames.AEHbl)} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Memo List', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.AEHbl} />, popupLabel: 'Memo List (HAWB)', moreMenuJobName: JobNames.AEHbl },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)', moreMenuJobName: JobNames.AEHbl },
        // { text: 'Package Label', level: 1, popupComponent: <PackageLabel jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Packing List', level: 1, popupComponent: <CommercialInvoice selectedElementId={null} jobName={JobNames.RptPackingList} tbName={getTbNameByJobName(JobNames.AEHbl)} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Shipping Advice', level: 1, popupComponent: <ShippingAdvice jobName={JobNames.AEHbl} selectedElement={null} />, moreMenuJobName: JobNames.AEHbl },
        // { text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.AEHbl} selectedElementId={null} />, moreMenuJobName: JobNames.AEHbl },

        //Download MAWB More Menu
        // { text: 'Download MAWB (All) List', level: 1, moreMenuJobName: JobNames.AEMPims },
        // { text: 'Download MAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AEMPims },
        // { text: 'Download MAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AEMPims },

        //Download HAWB More Menu
        // { text: 'Download HAWB (All) List', level: 1, moreMenuJobName: JobNames.AEHPims },
        // { text: 'Download HAWB (Downloaded) List', level: 1, moreMenuJobName: JobNames.AEHPims },
        // { text: 'Download HAWB (Not Downloaded) List', level: 1, moreMenuJobName: JobNames.AEHPims },
      ]
    },
    // Other Shipment
    {
      operation: constants.operations.otherShipment,
      job: [
        {
          text: 'Other Shipment List', level: 0,
          link: '/common/joblistview/otherShipment/otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/otherShipment/otherShipment'),
          fmsSecTask: FmsSecTask.OtherOP,
          moreMenuJobName: JobNames.OtherOP,
        },
        {
          text: 'Container List', level: 0,
          link: '/common/joblistview/OTOPC/otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OTOPC/otherShipment'),
          fmsSecTask: FmsSecTask.OtherOP,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'Quotation', level: 0,
          link: '/common/joblistview/otQuotation/otherShipment',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/otQuotation/otherShipment'),
          fmsSecTask: FmsSecTask.OTQuot,
        },
        {
          text: 'Invoice', level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Bill', level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        {
          text: 'CrDb', level: 0,
          link: '/common/joblistview/crdb/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
          fmsSecTask: FmsSecTask.AcctCrDbList
        },
        {
          text: `AMS`,
          level: 0,
          name: 'ams',
          link: '/common/joblistview/AMSM/ams',
          textColor: 'orangered',
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: `ISF`,
          level: 0,
          name: 'isf',
          link: '/common/joblistview/ISFL/isf',
          textColor: 'orangered',
        },
        {
          text: `AES Filing`,
          level: 0,
          name: 'aesFiling',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        {
          text: `In-bond`,
          level: 0,
          name: 'inbond',
          textColor: 'orangered',
          metadata: { isDirectPrint: true }
        },
        // {
        //   text: 'Freight Receipt', level: 0,
        //   link: '/common/joblistview/whReceipt/otherShipment',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceipt/otherShipment'),
        //   fmsSecTask: FmsSecTask.WHRcpt
        // },
      ],
      download: [],
      preReport: [
        // {
        //   text: 'Billings', level: 0,
        //   items: [
        //     {text: 'Invoice List', level: 1, link: '/common/joblistview/invoice/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting')},
        //     {text: 'Bill List', level: 1, link: '/common/joblistview/bill/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting')},
        //     {text: 'CrDb List', level: 1, link: '/common/joblistview/crdb/accounting', isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting')},
        //   ]
        // },
      ],
      report: [
        // {
        //   text: 'Report', level: 0,
        //   items: [
        //     // {text: 'Invoice List', level: 1},
        //     // {text: 'Bill List', level: 1},
        //     // {text: 'CrDb List', level: 1},
        //     {text: 'Est. Profit/Volume Summary Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.TentativeMargin} opType='otherShipment' isManagerReport/> },
        //     {text: 'Gross Profit/Volume Summary Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.Profit} opType='otherShipment' isManagerReport/> },
        //     {text: 'Vendor Cost Report', level: 1, popupComponent: <VendorCostDetails opType={'otherShipment'} />},
        //     {text: 'Volume Report', level: 1, popupComponent: <VolumeReportDetails opType={'otherShipment'} /> },
        //     {text: 'Sales Performance Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.ProfitSman} isManagerReport opType={'otherShipment'}  /> },
        //     {text: 'Customer Activity Report', level: 1, popupComponent: <CustomerActivityDetails />},
        //     {text: 'Duty Pendings', level: 1, popupComponent: <DutyPendingDetails />},
        //     {text: 'Issue Ready Invoice Report', level: 1},
        //     {text: 'Issue Ready Bill Report', level: 1},
        //     {text: 'Issue Ready Cr/Db Report', level: 1},
        //     {text: 'Operation Performance Report', level: 1, popupComponent: <OperationPerformanceDetails />},
        //     {text: 'Branch Performance Report', level: 1, popupComponent: <BranchPerformanceDetails />},
        //   ]
        // },
      ],
      moreMenu: [
        //Other Shipment More Menu
        // { text: 'AES Filing', level: 1, subMenu: FmsSubMenu.AesOtherOP, moreMenuJobName: JobNames.OtherOP},
        {
          text: 'Delivery Order',
          level: 1,
          link: '/otherShipment/shortDeliveryOrder?jobname=@jobName&id=@jobid&docType=81',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/shortDeliveryOrder/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Delivery Order (Short Form)', level: 1, popupComponent: <DeliveryOrder jobName={JobNames.OtherOP} selectedElement={null} docType={DocumentType.DeliveryOrderShort} />, popupWidth: 760, moreMenuJobName: JobNames.OtherOP, topLineColor: borderColors[0 % borderColors.length]  },
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/otherShipment/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/pickupDelivery/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.OtherOP} docType={DocumentType.Pickup} selectedElementId={null} />, popupWidth:760, moreMenuJobName: JobNames.OtherOP },
        {
          text: 'Est. Profit',
          level: 1,
          subMenu: FmsSubMenu.MasterProfit,
          moreMenuJobName: JobNames.OtherOP,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Gross Profit', level: 1,
          subMenu: FmsSubMenu.MasterProfitHBL,
          moreMenuJobName: JobNames.OtherOP
        },
        // {
        //   text: 'Folder Label', level: 1, subMenu: FmsSubMenu.FolderLabel,
        //   moreMenuJobName: JobNames.OtherOP,
        //   //topLineColor: borderColors[2 % borderColors.length],
        //   metadata: { isDirectPrint: true }
        // },            
        {
          text: 'Folder Label',
          level: 1,
          link: '/otherShipment/folderLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/folderLabel/'),
          moreMenuJobName: JobNames.OtherOP
        },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/otherShipment/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/straightBl/'),
          moreMenuJobName: JobNames.OtherOP
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.OtherOP} selectedElementId={null} />, popupWidth:760, moreMenuJobName: JobNames.OtherOP },
        {
          text: 'CBP Status Query',
          level: 1,
          textColor: 'orangered',
          link: '/otherShipment/cargoManifestStatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/otherShipment/cargoManifestStatus/'),
          moreMenuJobName: JobNames.OtherOP,
          //topLineColor: borderColors[3 % borderColors.length]
        },
      ]
    },

    //Change name W/H Receipt -> Freight Receipt
    //Other Shipment Side Menu -> Main Menu
    //Freight Receipt
    {
      operation: constants.operations.whReceipt,
      job: [
        {
          text: 'Freight Receipt List', level: 0,
          link: '/common/joblistview/whReceipt/whReceipt',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceipt/whReceipt'),
          fmsSecTask: FmsSecTask.WHRcpt,
          moreMenuJobName: JobNames.WHRcpt,
        }
      ],
      download: [],
      preReport: [],
      report: [],
      moreMenu: [
        //Freight Receipt More Menu
        { text: 'Freight Arrival Notice', level: 1, subMenu: FmsSubMenu.FArrivalNotice, moreMenuJobName: JobNames.WHRcpt },
        {
          text: 'Freight Receipt Label',
          level: 1,
          link: '/warehousing/receiptLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/receiptLabel/'),
          moreMenuJobName: JobNames.WHRcpt
        },
        {
          text: 'Received Cargo Status',
          level: 1,
          link: '/warehousing/receivedcargostatus?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/receivedcargostatus/'),
          moreMenuJobName: JobNames.WHRcpt
        },
        // { text: 'Warehouse Receipt Label', level: 0, popupComponent: <ReceiptLabel selectedElementId={null} />, popupWidth: 760 },
        // { text: 'Received Cargo Status', level: 0, popupComponent: <ReceivedCargoStatus selectedElementId={null} />, popupWidth: 760 },
      
        
      ]
    },
    // Warehousing
    {
      operation: constants.operations.warehousing,
      job: [
        {
          text: 'Receiving', level: 0,
          link: '/common/joblistview/whReceiving/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whReceiving/warehousing'),
          fmsSecTask: FmsSecTask.WHRcv,
          moreMenuJobName: JobNames.WHRcv,
        },
        {
          text: 'Shipping', level: 0,
          link: '/common/joblistview/whShipping/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whShipping/warehousing'),
          fmsSecTask: FmsSecTask.WHShip,
          moreMenuJobName: JobNames.WHShip,
        },
        {
          text: 'Inventory', level: 0,
          link: '/common/joblistview/whInventory/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whInventory/warehousing'),
          fmsSecTask: FmsSecTask.WHInvenSummary,
          topLineColor: borderColors[0 % borderColors.length]
        },
        {
          text: 'In/Out Activity', level: 0,
          link: '/common/joblistview/whInOut/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whInOut/warehousing'),
          fmsSecTask: FmsSecTask.WHInvenDetail,
        },
        {
          text: 'Invoice (WH)', level: 0,
          link: '/common/joblistview/invoice/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/warehousing'),
          fmsSecTask: FmsSecTask.WHInvoice,
          topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Bill (WH)', level: 0,
          link: '/common/joblistview/bill/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/warehousing'),
          fmsSecTask: FmsSecTask.WHBill
        },
        {
          text: 'CrDb (WH)', level: 0,
          link: '/common/joblistview/crdb/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/warehousing'),
          fmsSecTask: FmsSecTask.WHCrDb
        },
        {
          text: 'Storage Invoice', level: 0,
          link: '/common/joblistview/whStorageInvoice/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whStorageInvoice/warehousing'),
          fmsSecTask: FmsSecTask.WHStorageInv
        },
        {
          text: 'Customer (WH)', level: 0,
          link: '/common/joblistview/whCompany/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whCompany/warehousing'),
          fmsSecTask: FmsSecTask.WHCustomer,
          topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: 'Item (WH)', level: 0,
          link: '/common/joblistview/whItem/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whItem/warehousing'),
          fmsSecTask: FmsSecTask.WHItem,
        },
        {
          text: 'Location (WH)', level: 0,
          link: '/common/joblistview/whLocation/warehousing',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whLocation/warehousing'),
          fmsSecTask: FmsSecTask.WHLoc,
        },
        {
          text: 'Chargeable Item Report', level: 0,
          link: '/warehousing/chargeItemSummary?jobname=@jobName&id=@jobid&docType=101',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/chargeItemSummary/'),
          fmsSecTask: FmsSecTask.WHRptChargeItemSummary,
          topLineColor: borderColors[3 % borderColors.length]
        },
        {
          text: 'Customer In/Out Report', level: 0,
          link: '/warehousing/CustomerInNOut?jobname=@jobName&id=@jobid&docType=186',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/customerInNOut'),
          fmsSecTask: FmsSecTask.WHRptCustomerInNOut,
        },
        // {
        //   text: 'Company (WH)', level: 0,
        //   link: '/common/joblistview/whCompany/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whCompany/warehousing'),
        // },
        // {
        //   text: 'Item (WH)', level: 0,
        //   link: '/common/joblistview/whItem/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whItem/warehousing'),
        // },
        // {
        //   text: 'Location (WH)', level: 0,
        //   link: '/common/joblistview/whLocation/warehousing',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/whLocation/warehousing'),
        // },
      ],
      download: [],
      report: [],
      operationReport: [],
      moreMenu: [
        //Receiving More Menu
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/warehousing/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/pickupDelivery/'),
          moreMenuJobName: JobNames.WHRcv,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.WHRcv} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.WHRcv, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/warehousing/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/straightBl/'),
          moreMenuJobName: JobNames.WHRcv,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.WHRcv} selectedElementId={null} />, moreMenuJobName: JobNames.WHRcv },
        { text: 'Warehouse Receipt', level: 1, subMenu: FmsSubMenu.WReceipt, moreMenuJobName: JobNames.WHRcv },
        { text: 'Warehouse Receiving Label', level: 1, subMenu: FmsSubMenu.WLabelReceive, moreMenuJobName: JobNames.WHRcv },

        //Shipping More Menu
        {
          text: 'Pickup/Delivery Instruction',
          level: 1,
          link: '/warehousing/pickupDelivery?jobname=@jobName&id=@jobid&docType=18',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/pickupDelivery/'),
          moreMenuJobName: JobNames.WHShip,
          //topLineColor: borderColors[0 % borderColors.length]
        },
        //{ text: 'Pickup/Delivery Instruction', level: 1, popupComponent: <PickupDelivery jobName={JobNames.WHShip} docType={DocumentType.Pickup} selectedElementId={null} />, moreMenuJobName: JobNames.WHShip, topLineColor: borderColors[0 % borderColors.length] },
        {
          text: 'Straight B/L',
          level: 1,
          link: '/warehousing/straightBl?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/warehousing/straightBl/'),
          moreMenuJobName: JobNames.WHShip,
        },
        //{ text: 'Straight B/L', level: 1, popupComponent: <StraightBl jobName={JobNames.WHShip} selectedElementId={null} />, moreMenuJobName: JobNames.WHShip },
        { text: 'Pickup Slip', level: 1, subMenu: FmsSubMenu.WShip, moreMenuJobName: JobNames.WHShip },
        { text: 'Warehouse Shipping Label', level: 1, subMenu: FmsSubMenu.WLabelShip, moreMenuJobName: JobNames.WHShip },
      ]
    },
    // Manifest
    {
      operation: constants.operations.order,
      job: [
        {
          text: 'Manifest', level: 0,
          link: '/common/joblistview/btOrder/order',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/btOrder/order'),
          fmsSecTask: FmsSecTask.BTOrder,
          moreMenuJobName: JobNames.BTOrder,
        },
      ],
      download: [],
      report: [],
      operationReport: [],
      moreMenu: [
            //Order More Menu
            {
              text: 'CBP Status Query',
              level: 1,
              link: '/brokerageTrucking/cargoManifestStatus?jobname=@jobName&id=@jobid',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/brokerageTrucking/cargoManifestStatus/'),
              moreMenuJobName: JobNames.BTOrder,
              textColor: 'orangered',
            },
            {
              text: 'Est. Manifest Profit',
              level: 1,
              subMenu: FmsSubMenu.HouseProfit,
              moreMenuJobName: JobNames.BTOrder,
            },
            { text: 'Manifest (Shipper)', level: 1, subMenu: FmsSubMenu.BTManifestShip, moreMenuJobName: JobNames.BTOrder, topLineColor: '#d9d9d9' },
            { text: 'Manifest (Broker)', level: 1, subMenu: FmsSubMenu.BTManifestBrok, moreMenuJobName: JobNames.BTOrder },
            { text: 'Cargo Receipt', level: 1, subMenu: FmsSubMenu.BTCargoReceipt, moreMenuJobName: JobNames.BTOrder },
            { text: 'Manifest (C/O)', level: 1, subMenu: FmsSubMenu.BTManifestCO, moreMenuJobName: JobNames.BTOrder },
            { text: 'Worksheet', level: 1, subMenu: FmsSubMenu.BTWorkSheet, moreMenuJobName: JobNames.BTOrder },
            { text: 'Container Status Memo', level: 1, subMenu: FmsSubMenu.BTCntrStatusMemo, moreMenuJobName: JobNames.BTOrder },
            { text: 'Freight Invoice', level: 1, subMenu: FmsSubMenu.BTFreightInvoice, moreMenuJobName: JobNames.BTOrder },
            { text: 'CNTR Tracking Info', level: 1, subMenu: FmsSubMenu.BTCNTRTracking, moreMenuJobName: JobNames.BTOrder, topLineColor:'#d9d9d9' },
      ]
    },
    // Load
    {
      operation: constants.operations.load,
      job: [
        {
          text: 'Load', level: 0,
          link: '/common/joblistview/btLoadPlan/load',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/btLoadPlan/load'),
          fmsSecTask: FmsSecTask.BTLoadPlan,
          moreMenuJobName: JobNames.BTLoadPlan,
        },
      ],
      download: [],
      report: [],
      operationReport: [],
      moreMenu: [
            //Load More Menu
            {
              text: 'Est. Load Profit',
              level: 1,
              subMenu: FmsSubMenu.MasterProfit,
              moreMenuJobName: JobNames.BTLoadPlan,
            },
            { text: 'Gross Load Profit', level: 1, subMenu: FmsSubMenu.MasterProfitHBL, moreMenuJobName: JobNames.BTLoadPlan },
            { text: 'Master Delivery Sheet', level: 1, subMenu: FmsSubMenu.BTMasterDeliverySheet, moreMenuJobName: JobNames.BTLoadPlan, topLineColor: '#d9d9d9' },
            { text: 'Delivery Instruction', level: 1, subMenu: FmsSubMenu.BTDeliveryInstruction, moreMenuJobName: JobNames.BTLoadPlan },
            { text: 'Loading Instruction', level: 1, subMenu: FmsSubMenu.BTLoadInstruction, moreMenuJobName: JobNames.BTLoadPlan },
            { text: 'Unloading Instruction', level: 1, subMenu: FmsSubMenu.BTUnloadInstruction, moreMenuJobName: JobNames.BTLoadPlan },
            {
              text: 'Folder Label',
              level: 1,
              link: '/brokerageTrucking/folderLabel?jobname=@jobName&id=@jobid',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/brokerageTrucking/folderLabel/'),
              moreMenuJobName: JobNames.BTLoadPlan
            },
      ]
    },
    // Local D/O
    {
      operation: constants.operations.localDO,
      job: [
        {
          text: 'Local D/O', level: 0,
          link: '/common/joblistview/btLocalDO/localDO',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/btLocalDO/localDO'),
          fmsSecTask: FmsSecTask.BTLocalDO,
          moreMenuJobName: JobNames.BTDo,
        },
      ],
      download: [],
      report: [],
      operationReport: [],
      moreMenu: [
            //Local DO More Menu
            { text: 'Delivery Order', level: 1, subMenu: FmsSubMenu.BTDeliveryOrder, moreMenuJobName: JobNames.BTDo },
            { text: 'Delivery Order (Carrier)', level: 1, subMenu: FmsSubMenu.BTDeliveryOrderC, moreMenuJobName: JobNames.BTDo },
            { text: 'Bill Of Lading', level: 1, subMenu: FmsSubMenu.BTBillOfLading, moreMenuJobName: JobNames.BTDo },
            { text: 'Bill Of Lading (Carrier)', level: 1, subMenu: FmsSubMenu.BTBillOfLadingC, moreMenuJobName: JobNames.BTDo },
      ]
    },

    // Accounting [230519 Before Change Code]
    // {
    //   operation: constants.operations.accounting,
    //   job: [
    //     {
    //       text: 'Invoice <span style="font-size: 0.8em;">(All)</span>',
    //       level: 0,
    //       link: '/common/joblistview/invoice/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
    //       fmsSecTask: FmsSecTask.AcctInvoiceList
    //     },
    //     {
    //       text: 'Bill <span style="font-size: 0.8em;">(All)</span>',
    //       level: 0,
    //       link: '/common/joblistview/bill/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
    //       fmsSecTask: FmsSecTask.AcctBillList
    //     },
    //     {
    //       text: 'CrDb <span style="font-size: 0.8em;">(All)</span>',
    //       level: 0,
    //       link: '/common/joblistview/crdb/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
    //       fmsSecTask: FmsSecTask.AcctCrDbList
    //     },
    //     {
    //       text: 'G. Billing', level: 0,
    //       items: [
    //         {
    //           text: 'G. Bill',
    //           level: 1,
    //           link: '/common/joblistview/acGeneralBill/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralBill/accounting'),
    //           fmsSecTask: FmsSecTask.AcctGBillList
    //         },
    //         {
    //           text: 'G. Invoice',
    //           level: 1,
    //           link: '/common/joblistview/acGeneralInvoice/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralInvoice/accounting'),
    //           fmsSecTask: FmsSecTask.AcctGInvoList
    //         },
    //       ]
    //     },

    //     // {
    //     //   text: 'Invoice/Bill/CrDb', level: 0,
    //     //   items: [
    //     //     { text: 'Invoice', level: 1 },
    //     //     { text: 'Bill', level: 1 },
    //     //     { text: 'CrDb', level: 1 },
    //     //     { text: 'General Invoice', level: 1 },
    //     //     { text: 'General Bill', level: 1 },
    //     //   ]
    //     // },
    //     {
    //       text: 'Customer Pay', level: 0,
    //       link: '/common/joblistview/acCustomerPayment/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPayment/accounting'),
    //       fmsSecTask: FmsSecTask.AcctCustPayment,
    //     },
    //     {
    //       text: 'Bill Pay', level: 0,
    //       link: '/common/joblistview/acBillPayment/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBillPayment/accounting'),
    //       fmsSecTask: FmsSecTask.AcctBillPayment,
    //     },
    //     {
    //       text: 'CC Pay', level: 0, link: '/common/joblistview/acCCPayment/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCCPayment/accounting'),
    //       fmsSecTask: FmsSecTask.AcctCCPayment,
    //     },
    //     {
    //       text: 'Deposit / Check Clear', level: 0,
    //       // link: '/common/joblistview/acDepositCheckClear/accounting',
    //       // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepositCheckClear/accounting'),
    //       popupComponent: <DepositCheckClearView mode={FormType.ModeAdd} onApply={(currentUrl: string) => {
    //         const refreshUrls = ['/common/joblistview/acBillPayment/accounting', '/common/joblistview/acCustomerPayment/accounting'];
    //         if (refreshUrls.includes(currentUrl)) {
    //           const channel = postal.channel('ifms-job-list');
    //           channel.publish('ifms-job-list.reload');
    //         }
    //       }} />,
    //       popupWidth: 840,
    //       popupTop: 50, 
    //       fmsSecTask: FmsSecTask.AcctDeposit,
    //     },
    //     // {
    //     //   text: 'Payment', level: 0,
    //     //   items: [
    //     //     {
    //     //       text: 'Customer Payment', level: 1,
    //     //       link: '/common/joblistview/acCustomerPayment/accounting',
    //     //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPayment/accounting'),
    //     //     },
    //     //     {
    //     //       text: 'Bill Payment', level: 1,
    //     //       link: '/common/joblistview/acBillPayment/accounting',
    //     //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBillPayment/accounting'),
    //     //     },
    //     //     {
    //     //       text: 'Credit Card Payment', level: 1, link: '/common/joblistview/acCCPayment/accounting',
    //     //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCCPayment/accounting'),
    //     //     },
    //     //   ]
    //     // },
    //     {
    //       text: 'Bank Transaction', level: 0,
    //       items: [
    //         {
    //           text: 'Undo Deposit Clear/\nCancel Check Clear', level: 1,
    //           // link: '/common/joblistview/acDepositCheckClear/accounting',
    //           // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepositCheckClear/accounting'),
    //           popupComponent: <UndoDepositCheckClearView mode={FormType.ModeAdd} onApply={(currentUrl: string) => {
    //             const refreshUrls = ['r/common/joblistview/acBillPayment/accounting', '/common/joblistview/acCustomerPayment/accounting'];
    //             if (refreshUrls.includes(currentUrl)) {
    //               const channel = postal.channel('ifms-job-list');
    //               channel.publish('ifms-job-list.reload');
    //             }
    //           }} />,
    //           popupWidth: 840,
    //           popupTop: 50, 
    //           metadata: {
    //             doubleLineInMenu: true,
    //           },
    //           fmsSecTask: FmsSecTask.AcctUndoDeposit
    //         },
    //         {
    //           text: 'Credit Card Clear', level: 1,
    //           // link: '/common/joblistview/acCreditCardClear/accounting',
    //           // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
    //           popupComponent: <CreditCardClearView mode={FormType.ModeAdd} />,
    //           popupWidth: 840,
    //           popupTop: 50, 
    //           fmsSecTask: FmsSecTask.AcctCCClear,
    //         },
    //         {
    //           text: 'Cancel Credit Card Clear', level: 1,
    //           // link: '/common/joblistview/acCreditCardClear/accounting',
    //           // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
    //           popupComponent: <CancelCreditCardClearView mode={FormType.ModeAdd} />,
    //           popupWidth: 840,
    //           popupTop: 50, 
    //           fmsSecTask: FmsSecTask.AcctCancelCCClear,
    //         },
    //         {
    //           text: 'Check Clear with Excel', level: 1,
    //           // link: '/common/joblistview/acCreditCardClear/accounting',
    //           // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
    //           popupComponent: <CheckClearWithExcel id="0" mode={FormType.ModeAdd} />,
    //           popupWidth: 840,
    //           popupTop: 50, 
    //           fmsSecTask: FmsSecTask.AcctChkClearWithExcel,
    //         },
    //         {
    //           text: 'Bank Transfer', level: 1,
    //           link: '/common/joblistview/acBankTransfer/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankTransfer/accounting'),
    //           fmsSecTask: FmsSecTask.AcctBankTransfer,
    //         },
    //         {
    //           text: 'Bank Recon', level: 1,
    //           link: '/common/joblistview/acBankRecon/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankRecon/accounting'),
    //           fmsSecTask: FmsSecTask.AcctBankRecon,
    //         },
    //         /*{
    //           text: 'Check Clear with Excel', level: 1,
    //           link: '/common/joblistview/acCheckClear/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCheckClear/accounting'),
    //         },*/
    //       ]
    //     },
    //   ],
    //   download: [],
    //   report: [
    //     {
    //       text: 'Aging', level: 0,
    //       popupComponent: <AgingReportDetails initialAgingOption={AgingReportEnum.AR_AGING}/>,
    //       popupWidth: 760,
    //       fmsSecTask: FmsSecTask.AcctAging,
    //     },
    //     {
    //       text: 'Statement', level: 0,
    //       items: [
    //         {text: 'Customer Statement', level: 1, popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType={''}/>, popupWidth: 760, popupTop: 50, fmsSecTask: FmsSecTask.AcctCustStatement },
    //         {text: 'Agent Statement', level: 1, popupComponent: <AgentStatementDetails tbId={''} customerName={''} />, popupWidth: 760, popupTop: 50, fmsSecTask: FmsSecTask.AcctAgentStatement},
    //         {
    //           text: 'Customer Pay Memo', level: 1,
    //           link: '/common/joblistview/acCustomerPaymentMemo/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPaymentMemo/accounting'),
    //           fmsSecTask: FmsSecTask.AcctCustPaymentMemo
    //         },
    //       ]
    //     },
    //     {
    //       text: 'Sales/Cost Recog', level: 0,
    //       items: [
    //         {
    //           text: 'Deferred Report', level: 1, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.DeferSummary} opType='accounting' isManagerReport={false} />, 
    //           popupWidth: 760, 
    //           fmsSecTask: FmsSecTask.SCRecogDeferred 
    //         },
    //         {text: 'Batch Recog', level: 1, popupComponent: <BatchRecogDetails/>, popupWidth: 1120, popupTop: 50, fmsSecTask: FmsSecTask.SCRecogBatchRecog },
    //       ]
    //     },
    //     {
    //       text: 'Accounting Assist', level: 0,
    //       items: [
    //         {text: 'Daily Accounting Summary', level: 1, popupComponent: <DailyAccountingSummaryDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctDailyAcctSummary},
    //         {text: 'Account Balance', level: 1, popupComponent: <AccountBalanceDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctBalByEntity},
    //         {text: 'Account Ledger', level: 1, popupComponent: <AccountLedgerByEntityDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctLedger},
    //         {text: 'General Ledger', level: 1, popupComponent: <GeneralLedgerDetails documentType={DocumentType.NewGeneralJournal}/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctGeneralLedger},
    //       ]
    //     },
    //     {
    //       text: 'Financial Report', level: 0,
    //       items: [
    //         {text: 'Income Statement', level: 1, popupComponent: <IncomeStatementDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctIncomeStatement},
    //         {text: 'Balance Sheet', level: 1, popupComponent: <BalanceSheetDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctBalanceSheet},
    //         {text: 'Trial Balance', level: 1, popupComponent: <TrialBalanceDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctTrialBalance},
    //       ]
    //     },
    //     {
    //       text: 'Period/Year End', level: 0,
    //       items: [
    //         {text: 'Period Closing', level: 1, popupComponent: <PeriodClosingDetails/>, fmsSecTask: FmsSecTask.AcctPeriodClosing},
    //         {text: 'Year End Processing', level: 1, popupWidth: 510, popupTop: 50, popupComponent: <YearEndProcessingDetails/>, fmsSecTask: FmsSecTask.AcctEndYearProc},  
    //       ]
    //     },
    //     {
    //       text: 'General Accounting', level: 0,
    //       items: [
    //         {
    //           text: 'Payroll Summary', level: 1,
    //           link: '/common/joblistview/acPayroll2/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPayroll2/accounting'),
    //           fmsSecTask: FmsSecTask.AcctPayroll
    //         },
    //         {
    //           text: 'Prepaid Expense Adjustment', level: 1,
    //           link: '/common/joblistview/acPrepaidExpenseAdjustment/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPrepaidExpenseAdjustment/accounting'),
    //           fmsSecTask: FmsSecTask.AcctPrepaidAdjustment,
    //         },
    //         {
    //           text: 'Depreciation Adjustment', level: 1,
    //           link: '/common/joblistview/acDepreciationAdjustment/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepreciationAdjustment/accounting'),
    //           fmsSecTask: FmsSecTask.AcctDepreciationAdjustment,
    //         },
    //         {
    //           text: 'Amortization Adjustment', level: 1,
    //           link: '/common/joblistview/acAmortizationAdjustment/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAmortizationAdjustment/accounting'),
    //           fmsSecTask: FmsSecTask.AcctAmortizationAdjustment,
    //         },
    //         {
    //           text: 'Bad Debt Expense', level: 1,
    //           link: '/common/joblistview/acBadDebtProcessing/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBadDebtProcessing/accounting'),
    //           fmsSecTask: FmsSecTask.AcctBadDebtExpense,
    //         },
    //         {
    //           text: 'Sales Tax Return', level: 1,
    //           link: '/common/joblistview/acSalesTaxReturn/accounting',
    //           isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acSalesTaxReturn/accounting'),
    //           fmsSecTask: FmsSecTask.AcctSalesTaxReturnList,
    //         },
    //       ]
    //     },
    //     {
    //       text: 'Journal', level: 0,
    //       link: '/common/joblistview/acJournal/accounting',
    //       isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acJournal/accounting'),
    //       fmsSecTask: FmsSecTask.AcctSlipJournalList,
    //     },
    //     {
    //       text: 'Memo List', level: 0,
    //       items: [
    //         {text: 'Reminder Task', level: 1, link: '/memoList?o=accounting&i=0', metadata: { op: constants.operations.accounting } },
    //         {text: 'Attached File', level: 1, link: '/memoList?o=accounting&i=1', metadata: { op: constants.operations.accounting }, fmsSecTask: FmsSecTask.UTAttachedFile },
    //       ]
    //     },
    //     {
    //       text: 'Log List', level: 0,
    //       items: [
    //         {text: 'Email Log List', level: 1, link: '/memoList?o=accounting&i=2', metadata: { op: constants.operations.accounting }, fmsSecTask: FmsSecTask.UTEmailLog },
    //         {text: 'Print Log List', level: 1, link: '/memoList?o=accounting&i=3', metadata: { op: constants.operations.accounting }, fmsSecTask: FmsSecTask.UTPrintLog },
    //         {text: 'Fax Log List', level: 1, link: '/memoList?o=accounting&i=4', metadata: { op: constants.operations.accounting }, fmsSecTask: FmsSecTask.UTFaxLog },
    //       ],
    //     },
    //   ]
    // },
    {
      operation: constants.operations.accounting,
      job: [
        {
          text: 'Bank Balance',
          level: 0,
          link: '/accounting/acBankBalanceView',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acBankBalanceView'),
          fmsSecTask: FmsSecTask.AcctBankBalance,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Bank Recon',
          level: 0,
          link: '/common/joblistview/acBankRecon/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankRecon/accounting'),
          fmsSecTask: FmsSecTask.AcctBankRecon,
        },
        {
          text: 'Daily Accounting Summary',
          level: 0,
          link: '/accounting/acDailyAccountingSummary',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDailyAccountingSummary'),
          fmsSecTask: FmsSecTask.AcctDailyAcctSummary,
        },
        {
          text: 'Customer Pay',
          level: 0,
          link: '/common/joblistview/acCustomerPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Bill Pay',
          level: 0,
          link: '/common/joblistview/acBillPayment/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBillPayment/accounting'),
          fmsSecTask: FmsSecTask.AcctBillPayment,
        },
        // {
        //   text: 'CC Pay',
        //   level: 0,
        //   link: '/common/joblistview/acCCPayment/accounting',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCCPayment/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCCPayment,
        // },
        // {
        //   text: 'Agent Pay',
        //   level: 0,
        //   link: '/common/joblistview/acAgentPayment/accounting',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAgentPayment/accounting'),
        //   fmsSecTask: FmsSecTask.AcctAgntPayment,
        // },
        // {
        //   text: 'Payment Prep',
        //   level: 0,
        //   link: '/common/joblistview/acPaymentPrep/accounting',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPaymentPrep/accounting'),
        //   fmsSecTask: FmsSecTask.AcctPaymentPrep,
        // },
        {
          text: 'Deposit / Check Clear',
          level: 0,
          // link: '/common/joblistview/acDepositCheckClear/accounting',
          // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepositCheckClear/accounting'),
          // popupComponent: <DepositCheckClearView mode={FormType.ModeAdd} onApply={(currentUrl: string) => {
          //   const refreshUrls = ['/common/joblistview/acBillPayment/accounting', '/common/joblistview/acCustomerPayment/accounting'];
          //   if (refreshUrls.includes(currentUrl)) {
          //     const channel = postal.channel('ifms-job-list');
          //     channel.publish('ifms-job-list.reload');
          //   }
          // }} />,
          // popupWidth: 840,
          // popupTop: 50, 
          link: '/accounting/acDepositCheckClear',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDepositCheckClear'),
          fmsSecTask: FmsSecTask.AcctDeposit,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Undo Deposit / Check Clear',
          level: 0,
          // link: '/common/joblistview/acDepositCheckClear/accounting',
          // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepositCheckClear/accounting'),
          // popupComponent: <UndoDepositCheckClearView mode={FormType.ModeAdd} onApply={(currentUrl: string) => {
          // 
          //   const refreshUrls = ['r/common/joblistview/acBillPayment/accounting', '/common/joblistview/acCustomerPayment/accounting'];
          //   if (refreshUrls.includes(currentUrl)) {
          //     const channel = postal.channel('ifms-job-list');
          //     channel.publish('ifms-job-list.reload');
          //   }
          // }} />,
          // popupWidth: 840,
          // popupTop: 50, 
          link: '/accounting/acUndoDepositCheckClear',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acUndoDepositCheckClear'),
          fmsSecTask: FmsSecTask.AcctUndoDeposit
        },
        // {
        //   text: 'Credit Card Clear',
        //   level: 0,
        //   // link: '/common/joblistview/acCreditCardClear/accounting',
        //   // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
        //   // popupComponent: <CreditCardClearView mode={FormType.ModeAdd} />,
        //   // popupWidth: 840,
        //   // popupTop: 50, 
        //   link: '/accounting/acCreditCardClear',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCreditCardClear'),
        //   fmsSecTask: FmsSecTask.AcctCCClear,
        // },
        // {
        //   text: 'Cancel Credit Card Clear',
        //   level: 0,
        //   // link: '/common/joblistview/acCreditCardClear/accounting',
        //   // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCreditCardClear/accounting'),
        //   // popupComponent: <CancelCreditCardClearView mode={FormType.ModeAdd} />,
        //   // popupWidth: 840,
        //   // popupTop: 50, 
        //   link: '/accounting/acCancelCreditCardClear',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCancelCreditCardClear'),
        //   fmsSecTask: FmsSecTask.AcctCancelCCClear,
        // },
        {
          text: 'Check Clear with Excel',
          level: 0,
          // popupComponent: <CheckClearWithExcelView mode={FormType.ModeAdd} onApply={(currentUrl: string) => {
          //   const refreshUrls = ['/common/joblistview/acBillPayment/accounting', '/common/joblistview/acCustomerPayment/accounting'];
          //   if (refreshUrls.includes(currentUrl)) {
          //     const channel = postal.channel('ifms-job-list');
          //     channel.publish('ifms-job-list.reload');
          //   }
          // }} />,
          // popupWidth: 840,
          // popupTop: 50, 
          link: '/accounting/acCheckClearwExcel',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/CheckClearwExcel'),
          fmsSecTask: FmsSecTask.AcctChkClearWithExcel,
        },
        {
          text: 'Bank Transfer',
          level: 0,
          link: '/common/joblistview/acBankTransfer/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBankTransfer/accounting'),
          fmsSecTask: FmsSecTask.AcctBankTransfer,
        },
        // {
        //   text: 'Aging',
        //   level: 0,
        //   popupComponent: <AgingReportDetails initialAgingOption={AgingReportEnum.AR_AGING} />,
        //   popupWidth: 760,
        //   fmsSecTask: FmsSecTask.AcctAging,
        //   topLineColor: '#d9d9d9'
        // },
        {
          text: 'Aging',
          level: 0,
          link: '/accounting/acAging',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAging'),
          fmsSecTask: FmsSecTask.AcctAgingAR,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Customer Statement',
          level: 0,
          // popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType={''} />,
          // popupWidth: 760,
          // popupTop: 50,
          link: '/accounting/acCustomerStatement?parentOp=accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCustomerStatement'),
          fmsSecTask: FmsSecTask.AcctCustStatement
        },
        // {
        //   text: 'Agent Statement',
        //   level: 0,
        //   // popupComponent: <AgentStatementDetails tbId={''} customerName={''} />,
        //   // popupWidth: 760,
        //   // popupTop: 50,
        //   link: '/accounting/acAgentStatement?parentOp=accounting',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAgentStatement'),
        //   fmsSecTask: FmsSecTask.AcctAgentStatement
        // },
        {
          text: 'Customer Pay Memo',
          level: 0,
          link: '/common/joblistview/acCustomerPaymentMemo/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acCustomerPaymentMemo/accounting'),
          fmsSecTask: FmsSecTask.AcctCustPaymentMemo
        },

        {
          text: 'Invoice',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Bill',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList
        },
        // {
        //   text: 'CrDb',
        //   level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList
        // },
        {
          text: 'G. Bill',
          level: 0,
          link: '/common/joblistview/acGeneralBill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralBill/accounting'),
          fmsSecTask: FmsSecTask.AcctGBillList
        },
        {
          text: 'G. Invoice',
          level: 0,
          link: '/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralInvoice/accounting'),
          fmsSecTask: FmsSecTask.AcctGInvoList
        },
        {
          text: 'Payroll (Old)',
          level: 0,
          link: '/common/joblistview/acPayrollSummary/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPayrollSummary/accounting'),
          fmsSecTask: FmsSecTask.AcctPayroll,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Payroll',
          level: 0,
          link: '/common/joblistview/acPayroll2/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPayroll2/accounting'),
          fmsSecTask: FmsSecTask.AcctPayroll,
        },
        {
          text: '<span style="color:gray;">iXpense<span>',
          level: 0,
          
        },
        {
          text: 'Sales / Cost Batch Recog',
          level: 0,
          items: [
            {
              text: 'Sales / Cost Batch Recog',
              level: 1,
              link: '/accounting/acSalesCostRecog/add',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acSalesCostRecog/add'),
              fmsSecTask: FmsSecTask.SCRecogBatchRecog,
              topLineColor: '#d9d9d9',
            },
            {
              text: 'Batch Recog History',
              level: 1,
              link: '/common/joblistView/acBatchRecogHistoy/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistView/acBatchRecogHistoy/accounting'),
            },
          ]
        },
        {
          text: 'Deferred Report',
          level: 0,
          link: '/accounting/acDeferredReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acDeferredReport'),
          fmsSecTask: FmsSecTask.SCRecogDeferred
        },
        {
          text: 'Account Balance',
          level: 0,
          link: '/accounting/acAccountBalance',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAccountBalance'),
          // popupComponent: <AccountBalanceDetails />, 
          // popupWidth: 760, 
          fmsSecTask: FmsSecTask.AcctBalByEntity,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Account Ledger',
          level: 0,
          link: '/accounting/acAccountLedger',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAccountLedger'),
          // popupComponent: <AccountLedgerByEntityDetails />, 
          // popupWidth: 760, 

          fmsSecTask: FmsSecTask.AcctLedger
        },
        {
          text: 'General Ledger',
          level: 0,
          link: '/accounting/acGeneralLedger',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acGeneralLedger'),
          //popupComponent: <GeneralLedgerDetails documentType={DocumentType.NewGeneralJournal} />, 
          //popupWidth: 760,

          fmsSecTask: FmsSecTask.AcctGeneralLedger
        },
        {
          text: 'Accounting Classify',
          level: 0,
          items: [
            {
              text: 'Prepaid Expense', level: 1,
              link: '/common/joblistview/acPrepaidExpenseAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acPrepaidExpenseAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctPrepaidAdjustment,
            },
            {
              text: 'Depreciation', level: 1,
              link: '/common/joblistview/acDepreciationAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acDepreciationAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctDepreciationAdjustment,
            },
            {
              text: 'Amortization', level: 1,
              link: '/common/joblistview/acAmortizationAdjustment/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acAmortizationAdjustment/accounting'),
              fmsSecTask: FmsSecTask.AcctAmortizationAdjustment,
            },
            {
              text: 'Bad Debt Expense', level: 1,
              link: '/common/joblistview/acBadDebtProcessing/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acBadDebtProcessing/accounting'),
              fmsSecTask: FmsSecTask.AcctBadDebtExpense,
            },
            {
              text: 'Sales Tax Return', level: 1,
              link: '/common/joblistview/acSalesTaxReturn/accounting',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acSalesTaxReturn/accounting'),
              fmsSecTask: FmsSecTask.AcctSalesTaxReturnList,
            },
          ],
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Journal',
          level: 0,
          link: '/common/joblistview/acJournal/accounting',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acJournal/accounting'),
          fmsSecTask: FmsSecTask.AcctSlipJournalList,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Financial Report',
          level: 0,
          items: [
            //{text: 'Income Statement', level: 1, popupComponent: <IncomeStatementDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctIncomeStatement},
            {
              text: 'Income Statement',
              level: 1,
              link: '/accounting/acIncomeStatement',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acIncomeStatement'),
              fmsSecTask: FmsSecTask.AcctIncomeStatement,
            },
            // {text: 'Balance Sheet', level: 1, popupComponent: <BalanceSheetDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctBalanceSheet},
            {
              text: 'Balance Sheet',
              level: 1,
              link: '/accounting/acBalanceSheet',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acBalanceSheet'),
              fmsSecTask: FmsSecTask.AcctBalanceSheet,
            },
            //  {text: 'Trial Balance', level: 1, popupComponent: <TrialBalanceDetails/>, popupWidth: 760, fmsSecTask: FmsSecTask.AcctTrialBalance},
            {
              text: 'Trial Balance',
              level: 1,
              link: '/accounting/acTrialBalance',
              isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acTrialBalance'),
              fmsSecTask: FmsSecTask.AcctTrialBalance,
            },
          ]
        },
        {
          text: 'Period Closing',
          level: 0,
          popupComponent: <PeriodClosingDetails />,
          fmsSecTask: FmsSecTask.AcctPeriodClosing,
          topLineColor: '#d9d9d9'
        },
        {
          text: 'Year End Processing',
          level: 0,
          popupWidth: 510,
          popupTop: 50,
          popupComponent: <YearEndProcessingDetails />,
          fmsSecTask: FmsSecTask.AcctEndYearProc
        },
      ],
      download: [],
      report: [],
      // moreMenu: [
      //   {
      //     text: 'More Menu',
      //     level: 0,
      //     items: [
      //       //Bill Pay More Menu
      //       // {text: 'Bank EDI (ARP)', level: 1, popupComponent: <BankEdi jobName={JobNames.BillPayment} selectedElementId={null} />, moreMenuJobName: JobNames.BillPayment },
      //       // {text: 'Print Check Attachment', level: 1, subMenu: FmsSubMenu.PrintCheckSlip, moreMenuJobName: JobNames.BillPayment},
      //       // { text: 'Print Messenger Slip', level: 1, subMenu: FmsSubMenu.PrintMessengerSlip, moreMenuJobName: JobNames.BillPayment },

      //       //Check Clear More Menu
      //       // {text: 'New Customer Pay',level: 1, moreMenuJobName: JobNames.CheckClear },
      //       // {text: 'New Bill Pay',level: 1, moreMenuJobName: JobNames.CheckClear  },
      //     ]
      //   },
      // ]
    },
    // Customer
    {
      operation: constants.operations.customer,
      job: [
        // {
        //   text: 'Agent Statement',
        //   level: 0,
        // },
        // {
        //   text: 'Customer Statement',
        //   level: 0,
        // },
        // {
        //   text: 'Email',
        //   level: 0,
        // },
        // {
        //   text: 'Fax',
        //   level: 0,
        // },
        // {
        //   text: 'Importer/Bond Query',
        //   level: 0,
        // },
        // {
        //   text: 'Last Transaction',
        //   level: 0,
        // },
        // {
        //   text: 'Memo List (Customer)',
        //   level: 0,
        // },
        // {
        //   text: 'PrePickup Order',
        //   level: 0,
        // },
        // {
        //   text: 'Print Customer Profile',
        //   level: 0,
        // },
        {
          text: 'Customer List', level: 0,
          link: '/common/joblistview/company/customer',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/company/customer'),
          fmsSecTask: FmsSecTask.CodeCompany,
          moreMenuJobName: JobNames.Company
        },
        // {
        //   text: 'Active/In-Action CUST Report', 
        //   level: 0,
        //   link: '/company/activeCustomer',
        //   fmsSecTask: FmsSecTask.OPRptCustomerActivity,
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/activeCustomer'),
        // },
      ],
      download: [],
      report: [],
      moreMenu: [
        //Company More Menu
        // {
        //   text: 'Agent Statement',
        //   level: 1,
        //   link: '/company/agentStatement?jobname=@jobName&id=@jobid',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/agentStatement/'),
        //   moreMenuJobName: JobNames.Company,
        //   //topLineColor: borderColors[0 % borderColors.length]
        // },
        {
          text: 'Customer Statement',
          level: 1,
          link: '/company/customerVendor?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/customerVendor/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'PrePickup Order',
          level: 1,
          link: '/company/pickupDelivery?jobname=@jobName&id=@jobid&docType=127',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/pickupDelivery/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Print Customer Profile',
          level: 1,
          subMenu: FmsSubMenu.CompanyProfile,
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[1 % borderColors.length]
        },
        {
          text: 'Internet Tracking Customers',
          level: 1,
          link: '/company/internetTrackingCustomers?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/internetTrackingCustomers/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Email', level: 1,
          subMenu: FmsSubMenu.SendEmail,
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[2 % borderColors.length]
        },
        {
          text: 'Fax',
          level: 1,
          subMenu: FmsSubMenu.SendFax, moreMenuJobName: JobNames.Company
        },
        {
          text: 'Importer/Bond Query',
          level: 1,
          link: '/company/importerBondQuery?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/importerBondQuery/'),
          moreMenuJobName: JobNames.Company,
          //topLineColor: borderColors[3 % borderColors.length]
        },
        {
          text: 'Last Transaction',
          level: 1,
          link: '/company/lastTransaction?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/lastTransaction/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Memo List (Customer)',
          level: 1,
          link: '/company/memoList?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/memoList/'),
          moreMenuJobName: JobNames.Company
        },
        {
          text: 'Customer Address Label Print',
          level: 1,
          link: '/company/companyAddressLabel?jobname=@jobName&id=@jobid',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/company/companyAddressLabel/'),
          moreMenuJobName: JobNames.Company
        },
        // { text: 'Agent Statement', level: 1, popupComponent: <AgentStatementDetails tbId={''} customerName={''} />, moreMenuJobName: JobNames.Company, topLineColor: borderColors[0 % borderColors.length] },
        // { text: 'Customer Statement', level: 1, popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType={''} />, moreMenuJobName: JobNames.Company },
        // { text: 'PrePickup Order', level: 1, popupComponent: <PickupDelivery jobName={JobNames.Company} docType={DocumentType.PrePickup} selectedElementId={null} />, moreMenuJobName: JobNames.Company },
        // { text: 'Print Customer Profile', level: 1, subMenu: FmsSubMenu.CompanyProfile, moreMenuJobName: JobNames.Company, topLineColor: borderColors[1 % borderColors.length] },
        // { text: 'Importer/Bond Query', level: 1, popupComponent: <ImporterBondQuery selectedElement={null} />, popupWidth: 550, moreMenuJobName: JobNames.Company, topLineColor: borderColors[3 % borderColors.length] },
        // { text: 'Last Transaction', level: 1, popupComponent: <LastTransaction selectedElement={null} />, moreMenuJobName: JobNames.Company },
        // { text: 'Memo List (Customer)', level: 1, popupComponent: <MemoList selectedElement={null} jobName={JobNames.Company} isCompany={true} />, moreMenuJobName: JobNames.Company },
        // {
        //   text: 'Customer Address Label Print',
        //   level: 0,
        //   popupComponent: <CompanyAddressLabel />,
        //   popupWidth: 550,
        //   fmsSecTask: FmsSecTask.CmpAddrPrint,
        // },
      ]
    },
    //OP Report
    {
      operation: constants.operations.opReport,
      job: [
        //{
        //  text: 'Duty Pendings', level: 0,
        //  link: '/opReport/dutyPendings',
        //  fmsSecTask: FmsSecTask.OPRptDutyPendings,
        //  isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/dutyPendings'),
        //},
        //{ text: 'Issue Ready Report', level: 0, fmsSecTask: FmsSecTask.OPRptIssueReady, subMenu: FmsSubMenu.IssueReady },
        {
          text: 'Est. Profit/Volume Report', level: 0,
          link: '/opReport/estProfit?docType=705&isManagerReport=true&opType=oceanImport',
          fmsSecTask: FmsSecTask.OPRptEstProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/estProfit'),
        },
        {
          text: 'Gross Profit/Volume Report', level: 0,
          link: '/opReport/grossProfit?docType=23&isManagerReport=true&opType=oceanImport',
          fmsSecTask: FmsSecTask.OPRptGrossProfit,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/grossProfit'),
        },
        {
          text: 'Cost/Expense Report', level: 0,
          link: '/opReport/cost',
          fmsSecTask: FmsSecTask.OPRptVendorCost,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/cost'),
        },
        // {
        //   text: 'Expense Report', level: 0,
        //   link: '/opReport/expense',
        //   fmsSecTask: FmsSecTask.OPRptExpense,
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/expense'),
        // },
        //{
        //  text: 'Volume/Weight Report', level: 0,
        //  link: '/opReport/volume',
        //  fmsSecTask: FmsSecTask.OPRptVolume,
        //  isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/volume'),
        //},
        //{
        //  text: 'Salesperson Performance', level: 0,
        //  link: '/opReport/salesPerformance?docType=206&isManagerReport=true&opType=oceanImport',
        //  fmsSecTask: FmsSecTask.OPRptProfitBySalesman,
        //  isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/salesPerformance'),
        //},
        // {
        //   text: 'Customer Activity Report', level: 0,
        //   link: '/opReport/customerActivity',
        //   fmsSecTask: FmsSecTask.OPRptCustomerActivity,
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/customerActivity'),
        // },
        //{
        //  text: 'OP Performance Report', level: 0,
        //  link: '/opReport/opPerformance',
        //  fmsSecTask: FmsSecTask.OPRptOpPerfom,
        //  isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/opPerformance'),
        //},
        {
          text: 'Branch Performance Report', level: 0,
          link: '/opReport/branchPerformance',
          fmsSecTask: FmsSecTask.OPRptBranchPerform,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/opReport/branchPerformance'),
        },
        // {
        //   text: 'Invoice', level: 0,
        //   link: '/common/joblistview/invoice/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
        //   fmsSecTask: FmsSecTask.AcctInvoiceList,
        //   topLineColor: '#d9d9d9' 
        // },
        // {
        //   text: 'Bill', level: 0,
        //   link: '/common/joblistview/bill/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
        //   fmsSecTask: FmsSecTask.AcctBillList
        // },
        // {
        //   text: 'CrDb', level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=opReport',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList
        // },
      ],
      // job: [
      //   {text: 'Duty Pendings Report', level: 0, popupComponent: <DutyPendingDetails />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptDutyPendings},
      //   {text: 'Issue Ready Report', level: 0, fmsSecTask: FmsSecTask.OPRptIssueReady},
      //   {
      //     text: 'Est. Profit/Volume Report', level: 0, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.TentativeMargin} 
      //     opType='oceanImport' isManagerReport />, popupWidth: 760,
      //     fmsSecTask: FmsSecTask.OPRptEstProfit
      //   },
      //   {
      //     text: 'Gross Profit/Volume Report', level: 0, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.Profit} opType='oceanImport' isManagerReport />, 
      //     popupWidth: 760, fmsSecTask: FmsSecTask.OPRptGrossProfit 
      //   },
      //   {text: 'Cost Report', level: 0, popupComponent: <VendorCostDetails opType={'oceanImport'} />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptVendorCost},
      //   {text: 'Volume Report', level: 0, popupComponent: <VolumeReportDetails opType={'oceanImport'} />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptVolume },
      //   {
      //     text: 'Sales Performance Report', level: 0, popupComponent: <ProfitAndVolumeSummaryDetails documentType={DocumentType.ProfitSman} isManagerReport opType={'oceanImport'} />, 
      //     popupWidth: 760, fmsSecTask: FmsSecTask.OPRptProfitBySalesman 
      //   },
      //   {text: 'Customer Activity Report', level: 0, popupComponent: <CustomerActivityDetails />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptCustomerActivity},

      //   {text: 'OP Performance Report', level: 0, popupComponent: <OperationPerformanceDetails />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptOpPerfom},
      //   {text: 'Branch Performance Report', level: 0, popupComponent: <BranchPerformanceDetails />, popupWidth: 760, fmsSecTask: FmsSecTask.OPRptBranchPerform},
      // ],
      download: [],
      report: [],
    },
    //Utility
    {
      operation: constants.operations.utility,
      job: [
        {
          text: 'Communication Log List',
          level: 0,
          link: '/common/joblistview/utCommunication/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utCommunication/utility'),
          fmsSecTask: FmsSecTask.UTCommunication
        },
        {
          text: 'Email Log List',
          level: 0,
          link: '/common/joblistview/utEmail/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utEmail/utility'),
          fmsSecTask: FmsSecTask.UTEmailLog
        },
        {
          text: 'Print Log List',
          level: 0,
          link: '/common/joblistview/utPrint/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utPrint/utility'),
          fmsSecTask: FmsSecTask.UTPrintLog
        },
        {
          text: 'Fax Log List',
          level: 0,
          link: '/common/joblistview/utFax/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utFax/utility'),
          fmsSecTask: FmsSecTask.UTFaxLog
        },
        {
          text: 'Memo/Task List',
          level: 0,
          link: '/common/joblistview/utMemotask/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utMemotask/utility'),
          fmsSecTask: FmsSecTask.UTTaskMemoList
        },
        {
          text: 'Attached File List',
          level: 0,
          link: '/common/joblistview/utAttachedfile/utility',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/utAttachedfile/utility'),
          fmsSecTask: FmsSecTask.UTAttachedFile
        },
        // {
        //   //text: appContext.systemSettings?.showMilestoneInOihList ? 'B/L Activity Status Off (OIH List)': 'B/L Activity Status On (OIH List)',
        //   text: 'OIH B/L Activity Status On',
        //   level: 0,
        //   //link: '/common/joblistview/utFax/utility', 
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   //text: appContext.systemSettings?.showMilestoneInAihList ? 'B/L Activity Status Off (AIH List)': 'B/L Activity Status On (AIH List)',
        //   text: 'AIH B/L Activity Status On',
        //   level: 0,
        //   //link: '/common/joblistview/utFax/utility', 
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   text: `Denied Party (BIS) <img width='15px' height='15px' src=${previewPrintIcon} />`,
        //   level: 0,
        //   link: 'https://www.bis.doc.gov/index.php/policy-guidance/lists-of-parties-of-concern',
        //   metadata: { isDirectPrint: true }
        // },
        // {
        //   text: `Denied Party (OFAC) <img width='15px' height='15px' src=${previewPrintIcon} />`,
        //   level: 0, link: 'https://www.treas.gov/offices/enforcement/ofac/sdn/',
        //   metadata: { isDirectPrint: true }
        // },
        // {
        //   text: `Denied Party (ITAR) <img width='15px' height='15px' src=${previewPrintIcon} />`,
        //   level: 0, link: 'https://www.pmddtc.state.gov/',
        //   metadata: { isDirectPrint: true }
        // },
        // {
        //   text: 'Denied Party (BIS)',
        //   level: 0,
        //   link: 'https://www.bis.doc.gov/index.php/policy-guidance/lists-of-parties-of-concern'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   text: 'Denied Party (OFAC)',
        //   level: 0,
        //   link: 'https://www.treas.gov/offices/enforcement/ofac/sdn/'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        // {
        //   text: 'Denied Party (ITAR)',
        //   level: 0,
        //   link: 'https://www.pmddtc.state.gov/'
        //   //fmsSecTask: FmsSecTask.UTFaxLog
        // },
        {
          text: 'Check File Server',
          level: 0,
          //fmsSecTask: FmsSecTask.UTFaxLog
        },
      ],
      download: [],
      preReport: [],
      report: []
    },
    //Billings
    {
      operation: constants.operations.billings,
      moreMenuLocation: 'bottom',
      job: [
        {
          text: 'Invoice',
          level: 0,
          link: '/common/joblistview/invoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/invoice/accounting'),
          fmsSecTask: FmsSecTask.AcctInvoiceList,
        },
        {
          text: 'Bill',
          level: 0,
          link: '/common/joblistview/bill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/bill/accounting'),
          fmsSecTask: FmsSecTask.AcctBillList,
        },
        // {
        //   text: 'CrDb',
        //   level: 0,
        //   link: '/common/joblistview/crdb/accounting?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/crdb/accounting'),
        //   fmsSecTask: FmsSecTask.AcctCrDbList,
        // },
        {
          text: 'G. Invoice',
          level: 0,
          link: '/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralInvoice/accounting'),
          fmsSecTask: FmsSecTask.AcctGInvoList,
        },
        {
          text: 'G. Bill',
          level: 0,
          link: '/common/joblistview/acGeneralBill/accounting?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/acGeneralBill/accounting'),
          fmsSecTask: FmsSecTask.AcctGBillList,
        },
        
      ],
      download: [],
      preReport: [],
      report: [],
      moreMenu: [
        // View History  -----------------------------
        {
          text: 'View History',
          level: 0,
          subMenuNonReport: FmsSubMenu.OpenHistoryView,
        },
        // Delete History  -----------------------------
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.Bill,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.CrDb,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        {
          text: 'Delete History',
          link: '/common/deleteHistory?jobname=@jobName&id=@jobid',
          level: 1,
          moreMenuJobName: JobNames.GBill,
          subMenuNonReport: FmsSubMenu.OpenDeleteHistoryView,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/deleteHistory'),
        },
        // Auto Billing (G. Invoice Only)  -----------------------------
        {
          text: 'Auto Billing',
          level: 1,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          moreMenuJobName: JobNames.GInvo,
          subMenuNonReport: FmsSubMenu.AutoBillingView,
         // isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAutobilling'),
        },
        // Print  -----------------------------
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpInvoice,
          subMenu: FmsSubMenu.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.Invoice,
          subMenu: FmsSubMenu.Invoice,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpBill,
          fmsSecTask: FmsSecTask.AcctBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.Bill,
          fmsSecTask: FmsSecTask.AcctBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.OpCrDb,
          fmsSecTask: FmsSecTask.AcctCrDbList,
          subMenu: FmsSubMenu.CrDbNote,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.CrDb,
          fmsSecTask: FmsSecTask.AcctCrDbList,
          subMenu: FmsSubMenu.CrDbNote,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          moreMenuJobName: JobNames.GInvo,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          subMenu: FmsSubMenu.Invoice,
          topLineColor: '#cc00ff'
        },
        {
          text: 'Print',
          level: 1,
          fmsSecTask: FmsSecTask.AcctGBillList,
          subMenuNonReport: FmsSubMenu.PrintBill,
          moreMenuJobName: JobNames.GBill,
          topLineColor: '#cc00ff'
        },
        // Batch Print  -----------------------------
        {
          text: 'Batch Print',
          level: 1,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          moreMenuJobName: JobNames.OpInvoice,
          subMenuNonReport: FmsSubMenu.BatchPrint,
        },
        {
          text: 'Batch Print',
          level: 1,
          fmsSecTask: FmsSecTask.AcctInvoiceList,
          moreMenuJobName: JobNames.Invoice,
          subMenuNonReport: FmsSubMenu.BatchPrint,
        },
        {
          text: 'Batch Print',
          level: 1,
          fmsSecTask: FmsSecTask.AcctGInvoList,
          moreMenuJobName: JobNames.GInvo,
          subMenuNonReport: FmsSubMenu.BatchPrint,
        },
        // New Customer Pay  -----------------------------
        {
          text: 'New Customer Pay',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          subMenuNonReport: FmsSubMenu.NewCustomerPay,
          topLineColor: '#0079a4'
        },
      
        // New Bill Pay  -----------------------------
        {
          text: 'New Bill Pay',
          level: 0,
          subMenuNonReport: FmsSubMenu.NewBillPay,
          fmsSecTask: FmsSecTask.AcctBillPayment,
        },
        // Customer Pay List  -----------------------------
        {
          text: 'Customer Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.CustomerPayList,
          fmsSecTask: FmsSecTask.AcctCustPayment,
          topLineColor: '#ffc000',
          topLineShort: true,
        },
        // Bill Pay List  -----------------------------
        {
          text: 'Bill Pay List',
          level: 0,
          subMenuNonReport: FmsSubMenu.BillPayList,
          fmsSecTask: FmsSecTask.AcctBillPayment,
        },
        // View Payment History  -----------------------------
        {
          text: 'View Payment History',
          level: 0,
          subMenuNonReport: FmsSubMenu.ViewPaymenHistory,
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acPaymentHistoryView'),
        },
        // Customer Statement  -----------------------------
        {
          text: 'Customer Statement',
          level: 0,
          fmsSecTask: FmsSecTask.AcctCustStatement,
          link: '/accounting/acCustomerStatement?parentOp=billings',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acCustomerStatement'),
          topLineColor: '#ff0000'
        },
     
        // Agent Statement  -----------------------------
        // {
        //   text: 'Agent Statement',
        //   level: 0,
        //   fmsSecTask: FmsSecTask.AcctAgentStatement,
        //   link: '/accounting/acAgentStatement?parentOp=billings',
        //   isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/accounting/acAgentStatement'),
        // },
        // View Journal  -----------------------------
        {
          text: constants.List_Journal,
          level: 0,
          //moreMenuJobName: JobNames.OpInvoice,
          fmsSecTask: FmsSecTask.AcctSlipJournalList,
          subMenuNonReport: FmsSubMenu.SwitchJournal,
          topLineColor: '#84e291',
        },
      ],

    },
    //My Event
    {
      operation: constants.operations.myEvent,
      job:[
        {
          text: 'Master B/L',
          name: 'mbl',
          level: 0,
          link: '/common/joblistview/mbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/mbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIMbl,
        },
        {
          text: 'House B/L',
          name: 'hbl',
          level: 0,
          link: '/common/joblistview/hbl/oceanImport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/hbl/oceanImport'),
          fmsSecTask: FmsSecTask.OIHbl,
        },
      ],
      download: [],
      preReport: [],
      report: []
    },
    //AMS
    {
      operation : constants.operations.ams,
      job:[
        {
          text: 'AMS Filing',
          name: 'amsFiling',
          level: 0,
          subMenu: FmsSubMenu.AmsFiling,
        },
        {
          text: 'Voyage',
          name: 'voyage',
          level: 0,
          link: '/common/joblistview/AMSV/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSV/ams'),
          fmsSecTask: FmsSecTask.AMSVoyage,
        },
        {
          text: 'MBL',
          name: 'amsMbl',
          level: 0,
          link: '/common/joblistview/AMSM/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSM/ams'),
          fmsSecTask: FmsSecTask.AMSMaster,
        },
        {
          text: 'HBL',
          name: 'amsHbl',
          level: 0,
          link: '/common/joblistview/AMSH/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSH/ams'),
          fmsSecTask: FmsSecTask.AMSHouse,
        },
        {
          text: 'User',
          name: 'amsUser',
          level: 0,
          link: '/common/joblistview/AMSU/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMSU/ams'),
          fmsSecTask: FmsSecTask.AMSUser,
        },
        {
          text: 'AMS Branch',
          name: 'amsBranch',
          level: 0,
          link: '/common/joblistview/AMBR/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBR/ams'),
          fmsSecTask: FmsSecTask.AMSBranch,
        },
        {
          text: 'AMS Billing Code',
          name: 'amsBilling',
          level: 0,
          link: '/common/joblistview/AMBI/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMBI/ams'),
          fmsSecTask: FmsSecTask.AMSBilling,
        },
        {
          text: 'Filing History',
          name: 'amsFileHistory',
          level: 0,
          link: '/common/joblistview/AMHI/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMHI/ams'),
          fmsSecTask: FmsSecTask.AMSHistory,
        },
        {
          text: 'Customs Release History',
          name: 'amsCustHistory',
          level: 0,
          link: '/common/joblistview/AMC1/ams',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/AMC1/ams'),
          fmsSecTask: FmsSecTask.AMSC1History,
        }, {
          text: 'Usage Report',
          level: 0,
          link: '/ams/amsUsageReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsUsageReport'),
          fmsSecTask: FmsSecTask.AMSRptUsage
        }, {
          text: 'Lifting Report',
          level: 0,
          link: '/ams/amsLiftReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsLiftReport'),
          fmsSecTask: FmsSecTask.AMSRptLifting
        }, {
          text: 'Total Lifting Report',
          level: 0,
          link: '/ams/amsTotLiftReport',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/ams/amsTotLiftReport'),
          fmsSecTask: FmsSecTask.AMSRptTotalLifting
        },
      ],
      download: [],
      preReport: [],
      report: []
    },
    //Orchid Baro
    {
      operation: constants.operations.orchidBaro,
      job: [
        {
          text: 'Orchid Baaro', level: 0,
          link: '/common/joblistview/OCBO/orchidBaro',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/OCBO/orchidBaro'),
          fmsSecTask: FmsSecTask.OrchidBaro,
        },
        {text:'', level: 0, metadata:{emptyMenu: true}},
        {text:'', level: 0, metadata:{emptyMenu: true}},
        {text:'', level: 0, metadata:{emptyMenu: true} },
        {
          text: 'NOT DEPARTED', level: 0, 
          metadata: {isShipmentStatus: orchidBaroShipmentStatus[shipmentStatus.NotDeparted].color}
        },
        {
          text: 'IN TRANSIT', level: 0, 
          metadata: {isShipmentStatus: orchidBaroShipmentStatus[shipmentStatus.InTransit].color}
        },
        {
          text: 'PORT TERMINAL', level: 0,
          metadata: {isShipmentStatus: orchidBaroShipmentStatus[shipmentStatus.PortTerminal].color}
        },
        {
          text: 'LAX ORIGIN', level: 0, 
          metadata: {isShipmentStatus: orchidBaroShipmentStatus[shipmentStatus.LaxOrigin].color}
        },
        {
          text: 'IN INLAND TRANSIT', level: 0, 
          metadata: {isShipmentStatus: orchidBaroShipmentStatus[shipmentStatus.InInlandTransit].color}
        },
      ],
      download: [],
      preReport: [],
      report: []
    },
    //ISF
    {
      operation: constants.operations.isf,
      job:[
        {
          text: 'ISF Filing',
          name: 'isfFiling',
          level: 0,
          subMenu: FmsSubMenu.IsfFiling,
        },
        {
          text: 'ISF Upload',
          name: 'isfUpload',
          level: 0,
          subMenu: FmsSubMenu.IsfUpload,
        },
        {
          text: 'ISF List',
          name: 'isfList',
          level: 0,
          link: '/common/joblistview/ISFL/isf',
          isSelected: (_: any, c: string | null) => stringsStartsWithIgnoreCase(c, '/common/joblistview/ISFL/isf'),
          fmsSecTask: FmsSecTask.ISF,
        },
        {
          text: 'Std. ISF Excel Form (Download)',
          name: 'isfExcelDownload',
          level: 0
        },
      ],
      download: [],
      preReport: [],
      report: []
    }
  ],
};


export default config;
